<template>
    <a-spin :spinning="isLoading">
        <div class="tryExam" @copy.prevent @paste.prevent>
            <!-- Popup đợi -->
            <div v-if="showWaitPopup" class="wait-overlay">
                <div class="wait-popup">
                    <div class="wait-title">
                        Vui lòng đợi {{ waitSeconds }} giây để hệ thống hoàn tất xử lý bài thi của bạn.
                    </div>

                    <div class="wait-progress">
                        <div class="wait-progress-fill" :style="{ width: progress + '%' }"></div>
                    </div>
                </div>
            </div>
            <div class="tryExam-content containerTryExam"
                 :style="isAnalysisDetail ? 'background-color: white;' : ''"
            >
                <div
                    class="d-flex justify-content-between align-items-center tryExam-content__mobile"
                >
                    <div>
                        <h5 class="page-name mb-0">{{ dataRes.name }}</h5>
                    </div>
                    <div
                        class="d-flex align-items-center justify-content-between groupButtonScore w-100"
                        v-if="showingAnswer === true"
                    >
                        <div class="ml-0 ml-lg-4 d-flex align-items-center justify-content-center w-100">
                          <span class="mr-2 text-nowrap fsize-18"
                          >{{ $t("exam_student_result.label.total_mark") }}:</span
                          >
                            <button class="yellowButton px-4 py-1 fsize-18 fw-700" disabled>
                                {{ answerRes[0].total_of_score }}
                            </button>
                        </div>
                    </div>
                    <b-row align-v="center" class="tryExam-content__mobile--Date">
                        <b-col class="row p-0 align-items-center area-count-time" cols="6" lg="3">
                            <div v-if="showingAnswer === false" class="card-chart col">
                                <b-badge class="card-bar"></b-badge>
                                <b-badge
                                    class="card-bar card-bar__value bg-1"
                                    :style="{ width: (dataRes.time / timeDoExam) * 100 + '%' }"
                                />
                            </div>
                            <!-- Dong ho countdown -->
                            <b-input-group class="col time-count" align-v="center"
                                           v-if="showingAnswer === false"
                            >
                                <b-input-group-prepend is-text class="time-count__icon">
                                    <img class="" src="../../assets/images/Exam/clock.png" alt=""/>
                                </b-input-group-prepend>
                                <b-input
                                    v-model="timeOut"
                                    v-if="showingAnswer !== true"
                                    plaintext
                                    class="time-count__input"
                                ></b-input>
                                <b-input
                                    v-if="showingAnswer === true && typeExam !== `result`"
                                    :placeholder="
                                                secondsToHms(timeDoExam - this.dataRes.time) +
                                                  '/' +
                                                  secondsToHms(timeDoExam)
                                              "
                                    plaintext
                                    class="time-count__input"
                                ></b-input>
                                <b-input
                                    v-if="showingAnswer === true && typeExam === `result`"
                                    :placeholder="
                                                secondsToHms(duration) + '/' + secondsToHms(timeDoExam)
                                              "
                                    plaintext
                                    class="time-count__input"
                                ></b-input>
                                <p class="align-self-center text-minute fsize-17">
                                    {{ $t("exam_student_result.label.min") }}
                                </p>
                            </b-input-group>
                            <!-- End Dong ho countdown -->
                        </b-col>
                        <b-col class="text-lg-right text-center my-2 fsize-17">
                          <span class="text-nowrap"
                          >{{ $t("exam_student_result.label.date_play") }}:
                          </span>
                            {{ toDay }}
                        </b-col>
                    </b-row>
                </div>
                <!--<div
                    v-if="showingAnswer === true"
                    class="d-flex align-items-center justify-content-between w-100 mb-2 flex-wrap"
                >
                    <div class="d-flex align-items-center">
                        <p class="mr-4">
                            {{ $t("exam_student_result.label.grade") }}:
                            {{
                                answerRes[0].grade === -1
                                    ? this.$t("exam_student_result.label.no_grade")
                                    : answerRes[0].grade
                            }}
                        </p>
                        <div class="mr-2">
                            <b-icon icon="circle-fill" variant="" class="mr-2 status-true"></b-icon
                            >{{ $t("exam_student_result.label.true") }}
                        </div>
                        <div>
                            <b-icon icon="circle-fill" variant="" class="mr-2 status-false"></b-icon
                            >{{ $t("exam_student_result.label.false") }}
                        </div>
                    </div>
                </div>-->
                <!-- overview-result -->
                <div class="row col-12 fsize-18 color-black p-0 d-flex flex-column-reverse flex-lg-row"
                     v-if="showingAnswer === true"
                >
                    <div class="col-12 col-lg-8 px-0">
                        <!-- Hiện kết quả tổng quan sau khi submit -->
                        <div class="overview-result d-flex flex-wrap flex-column-reverse flex-md-row align-items-center">
                            <div class="col-12 col-md-8">
                                <div class="m-auto" style="width: 87%; margin-top: 35px !important; font-size: 14px">
                                    <div class="d-flex align-items-center">
                                        <p class="mr-4">
                                            {{ $t("exam_student_result.label.grade") }}:
                                            {{
                                                answerRes[0].grade === -1
                                                    ? this.$t("exam_student_result.label.no_grade")
                                                    : answerRes[0].grade
                                            }}
                                        </p>
                                        <div class="mr-2">
                                            <b-icon icon="circle-fill" variant="" class="mr-2 status-true"></b-icon
                                            >{{ $t("exam_student_result.label.true") }}
                                        </div>
                                        <div>
                                            <b-icon icon="circle-fill" variant="" class="mr-2 status-false"></b-icon
                                            >{{ $t("exam_student_result.label.false") }}
                                        </div>
                                    </div>
                                </div>
                                <div class="m-auto" style="width: 87%; margin-top: 35px !important;">
                                    <div v-if="correctListen > 0" class="d-flex flex-wrap align-items-center justify-content-between fsize-18 mb-2">
                                        <div style="width: 17%;">{{ $t("tryExam.listen") }}</div>
                                        <div style="width: 70%; position: relative;">
                                            <b-badge class="card-bar"></b-badge>
                                            <b-badge
                                                class="card-bar card-bar__value bg-1"
                                                :style="correctListen > 0 ? {width : ((correctListen / tQListen) * 100) + '%' } : { width : '0%'}"
                                            />
                                        </div>
                                        <div style="width: 13%;" class="text-right">{{ correctListen }}/{{ tQListen }}</div>
                                    </div>
                                    <div v-if="correctRead > 0" class="d-flex flex-wrap align-items-center justify-content-between fsize-18 mb-2">
                                        <div style="width: 17%;">{{ $t("tryExam.read") }}</div>
                                        <div style="width: 70%; position: relative;">
                                            <b-badge class="card-bar"></b-badge>
                                            <b-badge
                                                class="card-bar card-bar__value bg-1"
                                                :style="correctRead > 0 ? {width : ((correctRead / tQRead) * 100) + '%' } : { width : '0%'}"
                                            />
                                        </div>
                                        <div style="width: 13%;" class="text-right">{{ correctRead }}/{{ tQRead }}</div>
                                    </div>
                                    <p class="" style="font-size: 14px;"><i>{{ $t("tryExam.text_1") }}</i></p>
                                </div>
                            </div>
                            <div class="col-8 col-md-4">
                                <div class="m-auto col-10 text-center">
                                    <p class="fsize-18 fw-500 mb-2">{{ $t("tryExam.score_of_you") }}</p>
                                    <div class="total-my-score">
                                        {{ answerRes[0].total_of_mark }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Hiện kết quả tổng quan sau khi submit -->
                    </div>
                    <div class="col-12 col-lg-4 mb-3 mb-md-0 pl-0 pl-md-3 pr-0">
                        <!-- Thoi gian hoan thanh bai thi -->
                        <div class="area-time-complete text-center">
                            <p class="t-1">{{ $t("tryExam.time_did_of_you") }}</p>
                            <p class="t-2">
                                <img class="" src="../../assets/images/Exam/icon-clock.png" alt=""/>
                                <span>{{ formatTime(exam_actual_time) }}</span>
                            </p>
                            <p class="t-3">{{ $t("tryExam.total_time") }} <span>{{ formatTime(timeDoExam) }}</span></p>
                        </div>
                        <!-- End Thoi gian hoan thanh bai thi -->
                    </div>
                </div>
                <!-- End overview-result -->

                <!-- Button Tabs -->
                <div class="area-buttons-tabs my-4"
                     v-if="showingAnswer === true"
                >
                    <!-- chi tiết kết quả lam bài thi -->
                    <span class="mr-2"
                          :class="{act : isAnswerDetail}"
                          @click="handleTabAnswerDetail"
                    >{{ $t("tryExam.answer_detail") }}</span>

                    <!-- phân tích & thống kê kết quả bài thi -->
                    <span
                        v-if="!(this.user && this.user.business_id)"
                        :class="{act : isAnalysisDetail}"
                        @click="handleTabAnalysisDetail"
                    >{{ $t("tryExam.analysis_advance") }}</span>

                    <!-- lịch sử làm bài -->
                    <!--<span class="ml-2"
                          @click="handleLinkHistorySubmits"
                    >{{ $t("tryExam.history_submits") }}</span>-->

                    <!-- chụp ảnh bài thi -->
                    <span class="ml-2">
                        <screenshot></screenshot>
                    </span>
                </div>
                <!-- End Button Tabs -->

                <div class="row col-12 area-qa fsize-18 color-black p-0 flex-column-reverse flex-lg-row"
                     :class="(isAnswerDetail ? 'd-flex' : 'd-none')"
                >
                    <div class="col-12 col-lg-8 px-0">
                        <!-- Hiện thông báo nếu không có câu hỏi nào khi chọn nghe, nói, đọc, viết-->
                        <div class="no-q-noti"
                             v-if="isAll === false && ((tQRead === 0 && isRead === true) || (tQListen === 0 && isListen === true) || (tQSpeak === 0 && isSpeak === true) || (tQWrit === 0 && isWri === true))"

                        >
                            {{ $t("tryExam.text_2") }}
                        </div>
                        <!-- End Hiện thông báo nếu không có câu hỏi nào khi chọn nghe, nói, đọc, viết-->
                        <div
                            class="item-q"
                            v-for="(fData, index) in dataRes.question"
                            v-bind:key="fData.id"
                            ref="items"
                            :name="fData.type"
                            v-bind:class="fData.type === 'Listening' ? { act : isListen } : fData.type === 'Reading' ? { act : isRead } : fData.type === 'Speaking' ? { act : isSpeak } : fData.type === 'Writing' ? { act : isWri } : { act : isAll } "
                        >
                            <p class="number-question"

                            >
                                {{ $t("exam.label.question") }} {{ index + Number(index_seq) + 1 }}. ({{
                                    $t("exam_student_result.label.score")
                                }}: {{ fData.score }})
                            </p>
                            <!-- <ckeditor
                              :config="editorConfig"
                              :editor="editor"
                              @ready="onReady"
                              class="question-title pl-2  w-100"
                              rows="3"
                              disabled
                              v-model="fData.title"
                            >
                            </ckeditor> -->
                            <div class="t-question" v-html="clearFormatContent(fData.title)"></div>
                            <div class="d-flex pb-3 flex-column">
                                <b-img
                                    v-if="fData.image_s3"
                                    v-lazy
                                    :data-src="fData.image_s3"
                                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEA"
                                    class="questionImage "
                                    style="min-height: 20px; min-width: 20px;"
                                />
                                <div v-if="fData.embed_image_video">
                                    <img
                                        v-lazy
                                        :data-src="fData.embed_image_video"
                                        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEA"
                                        style="min-height: 20px; min-width: 20px;"
                                        class="questionImage"
                                        v-if="fData.embed_image_video.search('/embed/') === -1"
                                    />
                                </div>
                                <audio
                                    :ref="'audios-question-' + index"
                                    v-if="fData.audio_s3"
                                    :src="fData.audio_s3"
                                    id="audio-preview"
                                    controls
                                    controlsList="nodownload"
                                    class="py-2"
                                    @play="stopOthers('audios-question', index)"
                                />
                                <div>
                                    <a-button
                                        :id="'embedBtn' + index"
                                        type="primary"
                                        @click="showModalEmbed(index, fData)"
                                        :key="keyInput + 1"
                                        v-if="
                                            fData.embed_audio !== null ||
                                              fData.embed_image_video !== null
                                          "
                                    >
                                        {{ $t("exam_student_result.label.embedTitle") }}
                                    </a-button>
                                    <a-modal
                                        closable
                                        :id="'embed' + index"
                                        :visible="showModal[index]"
                                        :title="$t('exam_student_result.label.embedTitle')"
                                        @ok="showModalEmbed(index, fData)"
                                        @cancel="showModalEmbed(index, fData)"
                                        :key="keyInput + 1"
                                        width="800px"
                                    >
                                        <template slot="footer">
                                            <b-button
                                                key="submit"
                                                variant="primary"
                                                @click="showModalEmbed(index, fData)"
                                            >
                                                {{ $t("exam_student_result.button.close") }}
                                            </b-button>
                                        </template>
                                        <div
                                            :id="'embed' + fData.id"
                                            class="containerEmbedAudio"
                                            v-if="fData.embed_audio"
                                        >
                                            <div v-html="fData.embed_audio"></div>
                                        </div>
                                        <div v-if="fData.embed_image_video">
                                            <div
                                                class="containerEmbed mt-3"
                                                v-if="
                                                    fData.embed_image_video.search('/embed/') !== -1
                                                  "
                                            >
                                                <iframe
                                                    style="display: block"
                                                    width="560"
                                                    height="315"
                                                    :src="fData.embed_image_video"
                                                    title="YouTube video player"
                                                    frameborder="0"
                                                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    allowfullscreen
                                                ></iframe>
                                            </div>
                                        </div>
                                    </a-modal>
                                </div>
                                <video class="w-100" controls v-if="fData.video_s3">
                                    <source :src="fData.video_s3" />
                                </video>
                            </div>
                            <b-row class="fsize-16" v-if="fData.type !== 'Writing' && fData.type !== 'Speaking'">
                                <b-col

                                    class="p-0 mb-1 d-flex align-items-start answerShow col-12 col-lg-5"
                                    v-for="(ansData, i) in fData.answer"
                                    v-bind:key="i"
                                >
                                    <div
                                        class="p-0 mb-1 d-flex align-items-start answerShow w-100"
                                        :style="{
                        display: showingAnswer
                          ? `flex !important`
                          : `none !important`
                      }"
                                    >
                                        <div class="answerIndex" :id="'ans' + index + '_' + i">

                                        </div>
                                        <div class="ml-1" v-show="fData.manyAnswer !== 1"> {{ ansData.ans_id }}.</div>
                                        <b-img
                                            v-if="ansData.image_answer_s3"
                                            v-lazy
                                            :data-src="ansData.image_answer_s3"
                                            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEA"
                                            class="ml-1"
                                            style="min-height: 20px; min-width: 20px;"
                                        ></b-img>
                                        <p v-else class="ml-1" style="width: 80%;" v-html="clearFormatContent(ansData.ans_value)"></p>
                                    </div>
                                    <div
                                        v-if="!showingAnswer"
                                        class="p-0 mb-1 d-flex align-items-start answerShow w-100"
                                    >
                                        <div
                                            v-if="fData.answer_option === 'One choice' && fData.manyAnswer !== 1"
                                            class="d-flex align-items-center w-100"
                                        >

                                            <input
                                                type="radio"
                                                :name="'radio' + fData.id + ansData.ans_id"
                                                :value="i"
                                                v-model="dataSubmit[index].ans_id"
                                                class="mr-1"
                                                :data-question="'q' +index"
                                                @click="targetTableQuestion"
                                            />{{ ansData.ans_id }}.
                                            <b-img
                                                v-if="ansData.image_answer_s3"
                                                v-lazy
                                                :data-src="ansData.image_answer_s3"
                                                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEA"
                                                style="min-height: 20px; min-width: 20px;"
                                                class="ml-2"
                                            ></b-img>
                                            <p v-else class="ml-2" style="width: 80%;" v-html="clearFormatContent(ansData.ans_value)"></p>
                                        </div>
                                        <div>
                                            <input
                                                v-if="fData.manyAnswer === 1"
                                                name="text"
                                                v-model="userInput[index]"
                                                @input="filterNumber(index, i, ansData.ans_value, $event)"
                                                placeholder="Nhập đáp án..."
                                            />
                                            <!-- @input="checkAnswer(index, i, ansData.ans_value)" -->
                                        </div>
                                        <div
                                            v-if="fData.answer_option === 'Multiple choice'"
                                            class="d-flex justify-content-around w-100"
                                        >
                                            <input
                                                type="checkbox"
                                                :name="'radio' + fData.id"
                                                :value="i"
                                                v-model="dataSubmit[index].ans_id"
                                                class="mr-1"
                                                :data-question="'q' +index"
                                                @click="targetTableQuestion"
                                            />{{ ansData.ans_id }}.
                                            <b-img
                                                v-if="ansData.image_answer_s3"
                                                v-lazy
                                                :data-src="ansData.image_answer_s3"
                                                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEA"
                                                style="min-height: 20px; min-width: 20px;"
                                                class="ml-2"
                                            ></b-img>
                                            <p v-else class="ml-2" style="width: 80%; white-space: normal; word-wrap: break-word;" v-html="clearFormatContent(ansData.ans_value)"></p>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>

                            <!-- Viết câu trả lời đối với các câu hỏi 'Writing' -->
                            <div
                                v-if="
                      fData.type === 'Writing' &&
                      !fileSubmit[index] &&
                      showingAnswer === false
                  "
                                class=""
                                style="position: relative"
                            >
                                <b-form-textarea
                                    v-model="dataSubmit[index].answer"
                                    :id="'textarea' + fData.id"
                                    rows="3"
                                    max-rows="8"
                                ></b-form-textarea>
                                <div class="count_mess_and_up_file">
                                    <!-- Đếm số ký tự khi viết câu trả lời -->
                                    <span class="pull-right label label-default count_message" id="count_message">Số ký tự: {{dataSubmit[index].answer.length}}</span>
                                    <!-- End Đếm số ký tự khi viết câu trả lời -->

                                    <!-- Nút tải file -->
                                    <label class="mb-0" style="cursor: pointer;" title="Tải lên"
                                           :for="'form-upload-file' + fData.id"
                                           v-if="
                                            !fileSubmit[index] && dataSubmit[index].answer === ''
                                        ">
                                        <img src="../../assets/images/Exam/upload.png" alt="">
                                    </label>
                                    <!-- End Nút tải file -->

                                </div>
                            </div>
                            <!-- Viết câu trả lời đối với các câu hỏi 'Speaking' -->
                            <div
                                v-if="
                      fData.type === 'Speaking' &&
                      !fileSubmit[index] &&
                      showingAnswer === false
                  "
                                class=""
                                style="position: relative"
                            >
                                <!-- <b-form-textarea
                                    v-model="dataSubmit[index].answer"
                                    :id="'textarea' + fData.id"
                                    rows="3"
                                    max-rows="8"
                                    v-if="audioUpload[index] == ''"
                                ></b-form-textarea> -->
                                <div class="d-none count_mess_and_up_file">
                                    <!-- Đếm số ký tự khi viết câu trả lời -->
                                    <!-- <span v-if="audioUpload[index] == ''" class="pull-right label label-default count_message" id="count_message">Số ký tự: {{dataSubmit[index].answer.length}}</span> -->
                                    <!-- End Đếm số ký tự khi viết câu trả lời -->

                                </div>
                                <div class="mb-2">
                                    <span class="fw-600">Câu trả lời:</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-start">
                                    <!-- begin: upload audio -->
                                    <div
                                        v-if="!fileSubmit[index] && dataSubmit[index].answer === ''"
                                        class="d-flex align-items-center justify-content-between mr-2"
                                    >
                                        <div class="upload-audio" v-show="audioUpload[index] == '' && startRecord[index] !== true">
                                            <button
                                                class="upload-audio-button"
                                                :for="'upload-audio-input' + index"
                                                type="button"
                                            >
                                                <b-icon
                                                    icon="music-note-beamed"
                                                    font-scale="1.5"
                                                    style="margin-right: 5px"
                                                    variant="danger"
                                                ></b-icon>
                                                <label style="white-space: nowrap" :for="'upload-audio-input' + index">{{
                                                        $t("question_list.label.audio")
                                                    }}</label>
                                            </button>
                                            <b-form-file
                                                v-show="audioUpload[index] == ''"
                                                accept="audio/*"
                                                v-model="upload_audio_input[index]"
                                                @change="handleAudioUpload($event, index)"
                                                class="pr-1-audio"
                                                :id="'upload-audio-input' + index"
                                            ></b-form-file>
                                        </div>
                                    </div>

                                    <!-- end: upload audio -->

                                    <!-- record, ghi am truc tiep -->
                                    <div v-show="audioUpload[index] == ''">
                                        <recorder :maxTime="2" :index="index" @start-record="isStartRecord" @send-audio="recordAudio"></recorder>
                                    </div>
                                    <!-- end record, ghi am truc tiep -->
                                </div>

                            </div>
                            <!-- End Viết câu trả lời đối với các câu hỏi 'Speaking' -->

                            <!-- Show file khi tải file đối với các câu hỏi 'Writing -->
                            <div
                                v-if="fData.type === 'Writing' && showingAnswer === false"
                                class="`form-control-file`__label"
                            >
                                <b-form-file
                                    accept=".pdf, .doc, .docx"
                                    v-model:disabled="fileSubmit[index]"
                                    :placeholder="$t(`exam.label.update_image`)"
                                    :id="'form-upload-file' + fData.id"
                                    class="form-control-file"
                                    :key="keyInput"
                                >
                                </b-form-file>
                                <div
                                    class="d-flex align-items-center"
                                    v-if="fileSubmit[index]"
                                    :key="keyInput + 1"
                                >
                                    <div class="nameInputFile">
                                        {{ fileSubmit[index] ? fileSubmit[index].name : "" }}
                                    </div>
                                    <img
                                        @click="removeInputFile(index)"
                                        src="https://img.icons8.com/windows/25/undefined/cancel.png"
                                    />
                                </div>
                            </div>
                            <div
                                v-if="fData.type === 'Speaking' && showingAnswer === false"
                                class="`form-control-file`__label d-flex align-items-center"
                            >
                                <audio
                                    :ref="'audios-reply-' + index"
                                    id="form"
                                    :src="audioUpload[index]"
                                    controls
                                    controlsList="nodownload"
                                    v-show="audioUpload[index] != ''"
                                    @play="stopOthers('audios-reply',index)"
                                />
                                <ion-icon
                                    @click="removeAudio(index)"
                                    v-show="audioUpload[index] != ''"
                                    name="close-circle-outline"
                                    style="font-size: 35px; margin: 0 0px 0 8px; cursor: pointer;"
                                ></ion-icon>
                            </div>
                            <!-- End Show file khi tải file đối với các câu hỏi 'Writing -->

                            <!-- Writing & Speaking: show câu trả lời sau khi nộp bài -->
                            <div
                                v-if="
                    (fData.type === 'Writing' || fData.type === 'Speaking') &&
                      showingAnswer === true &&
                      answerRes[index].answer
                  "
                            >
                  <textarea
                      v-if="answerRes[index].answer.slice(0, 8) !== 'https://'"
                      disabled
                      rows="3"
                      class="w-100"
                  >
							{{ answerRes[index].answer }}
						</textarea>
                                <div v-if="fData.type === 'Writing' && answerRes[index].answer.slice(0, 8) === 'https://'">
                                    <a
                                        v-if="answerRes[index].answer.slice(0, 8) === 'https://'"
                                        :href="answerRes[index].answer"
                                    >
                                        <img
                                            src="https://img.icons8.com/office/30/undefined/download--v1.png"
                                        />
                                        {{ $t("exam_student_result.button.downloadAnsPDF") }}
                                    </a>
                                </div>
                                <div v-if="fData.type === 'Speaking' && answerRes[index].answer.slice(0, 8) === 'https://'">
                                    <span style="color: #6F84CA;">{{$t(`exam.label.audio_answer`)}}:</span><br>
                                    <audio
                                        :ref="'audios-answer-' + index"
                                        id="form"
                                        :src="answerRes[index].answer"
                                        controls
                                        controlsList="nodownload"
                                        @play="stopOthers('audios-answer', index)"
                                    />
                                </div>
                            </div>

                            <!-- Hiện đáp án được setup trong admin sau khi nộp bài -->
                            <div
                                v-if="showingAnswer === true"
                                class="justify-content-center d-flex flex-column mt-4"
                                :key="keyInput"
                            >
                                <div v-if="(fData.type === 'Speaking' || fData.type === 'Writing')">
                                    <span class="number-question" style="margin-bottom: 10px; color: #7ACC00">
                                        {{$t(`exam.label.lable_make_score`)}}: {{answerRes[index].score}}/{{ fData.score }}
                                    </span>
                                    <br v-if="answerRes[index].description">
                                    {{$t(`exam.label.lable_teacher_comment`)}}:
                                    <textarea
                                        v-if="answerRes[index].description"
                                        class="w-100 mt-4"
                                        rows="3"
                                        :placeholder="answerRes[index].description"
                                        disabled
                                    ></textarea>
                                </div>
                                <br v-if="answerRes[index].description">
                                <b-button
                                    v-if="answerRes[index].explain"
                                    class="yellowButton yellowButton__hover col-12 col-md-3"
                                    @click="handleShowExplain(index)"
                                >
                                    {{ $t("exam_student_result.button.explain") }}
                                </b-button>
                                <textarea
                                    v-if="
                      answerRes[index].explain && showExplain[index] === true
                    "
                                    class="w-100 mt-4"
                                    rows="3"
                                    v-model="answerRes[index].explain"
                                    disabled
                                ></textarea>
                                <div class="mt-2" v-if="showExplain[index] === true">
                                    <img
                                        v-lazy
                                        class="imageExplain"
                                        v-if="!handleShowPDF(answerRes[index].explain_path)"
                                        :data-src="answerRes[index].explain_path"
                                        src=""
                                        style="min-height: 20px; min-width: 20px;"
                                    />
                                    <a v-else :href="answerRes[index].explain_path">
                                        <img
                                            src="https://img.icons8.com/office/30/undefined/download--v1.png"
                                        />
                                        {{ $t("exam_student_result.button.downloadPDF") }}
                                    </a>
                                </div>
                            </div>
                            <!-- End Hiện đáp án được setup trong admin sau khi nộp bài -->

                        </div>

                    </div>
                    <div class="col-12 col-lg-4 pl-0 pl-md-3 pr-0"
                         :class="(showTableQuestions ? '' : 'fix-sticky')"
                    >
                        <div class="" style=""
                             :class="(showTableQuestions ? '' : 'area-table-ques')"
                        >
                            <div class="table-ques d-lg-block"
                                 :class="(showTableQuestions ? 'show_mobile' : 'd-none')"
                            >
                                <div class="op-type" v-if="!(this.user && this.user.business_id && this.user.business_id == 213)" style="margin: 15px 0;">
                                    <span data-name="all" @click="optionTypeQuestion" :class="{ act : isAll }">{{ $t("tryExam.all") }}</span>
                                    <span data-name="Listening" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isListen}">{{ $t("tryExam.listen") }}</span>
                                    <span data-name="Speaking" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isSpeak}">{{ $t("tryExam.speak") }}</span>
                                    <span data-name="Reading" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isRead}">{{ $t("tryExam.read") }}</span>
                                    <span data-name="Writing" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isWri}">{{ $t("tryExam.write") }}</span>
                                </div>
                                <!-- for hsa vnu step 3-->
                                <!--<div class="op-type" v-if="this.showScienceBlock" style="margin: 15px 0;">
                                    <span data-name="all" @click="optionTypeQuestion" :class="{ act : isAll }">{{ $t("tryExam.all") }}</span>
                                    <span data-name="Listening" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isListen}">{{ $t("tryExam.listen") }}</span>
                                    <span data-name="Speaking" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isSpeak}">{{ $t("tryExam.speak") }}</span>
                                    <span data-name="Reading" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isRead}">{{ $t("tryExam.read") }}</span>
                                    <span data-name="Writing" @click="optionTypeQuestion" :class="isAll === true ? {} : { act : isWri}">{{ $t("tryExam.write") }}</span>
                                </div>-->
                                <div class="list-nb-question">
                                    <!--<p class="fsize-18 mb-2">{{ $t("tryExam.total_question") }}: {{ totalQuestion }}</p>
                                    <p class="fsize-18 mb-2">{{ $t("tryExam.total_max_score") }}: {{ dataRes.score_ques_exam.reduce((acc, val) => acc + (parseFloat(val) || 0), 0) }}</p>-->
                                    <div class="nb-q mb-2">
                                        <!-- khi chon All thì hiện cái này -->
                                        <span
                                            v-for="(fData, index) in dataRes.question"
                                            v-bind:key="fData.id"
                                            @click="scrollToElement(index)"
                                            :id="'q' + index"
                                            :class="(fData.type !== 'Writing' && fData.type !== 'Speaking' && ((Array.isArray(dataSubmit[index].ans_id) === true && dataSubmit[index].ans_id.length !== 0) || (Array.isArray(dataSubmit[index].ans_id) === false && dataSubmit[index].ans_id >= 0) || (Array.isArray(dataSubmit[index].ans_id) === true && dataSubmit[index].answer_value != ''))) || (((fData.type === 'Writing' || fData.type === 'Speaking') && dataSubmit[index].answer !== '' && dataSubmit[index].answer !== 'noAnswer') || (fData.type === 'Writing' && fileSubmit[index] !== null) || (fData.type === 'Speaking' && audioUpload[index] !== '')) ? 'q_selected' : ''"
                                            v-show="(isAll === true) || (fData.type === 'Listening' && isListen === true) || (fData.type === 'Reading' && isRead === true) || (fData.type === 'Speaking' && isSpeak === true) || (fData.type === 'Writing' && isWri === true)"

                                        >
                                            {{ index + Number(index_seq) + 1 }}
                                        </span>
                                        <!-- End khi chon All thì hiện cái này -->

                                        <!-- khi chon Nghe thì hiện cái này -->
                                        <!-- <span
                                            v-for="(fData, index) in dataRes.question"
                                            v-bind:key="fData.id"
                                            @click="scrollToElement(index)"
                                            :id="'q' + index"
                                            :class="(fData.type !== 'Writing' && fData.type !== 'Speaking' && (dataSubmit[index].ans_id >= 0 && dataSubmit[index].ans_id.length !== 0)) || (((fData.type === 'Writing' || fData.type === 'Speaking') && dataSubmit[index].answer !== '' && dataSubmit[index].answer !== 'noAnswer') || (fData.type === 'Writing' && fileSubmit[index] !== null) || (fData.type === 'Speaking' && audioUpload[index] !== '')) ? 'q_selected' : ''"
                                            v-if="isAll === false && isListen === true && fData.type === 'Listening'"
                                                >
                                            {{ index + 1 }}
                                        </span> -->
                                        <!-- End khi chon Nghe thì hiện cái này -->

                                        <!-- khi chon Nói thì hiện cái này -->
                                        <!-- <span
                                            v-for="(fData, index) in dataRes.question"
                                            v-bind:key="fData.id"
                                            @click="scrollToElement(index)"
                                            :id="'q' + index"
                                            :class="(fData.type !== 'Writing' && fData.type !== 'Speaking' && (dataSubmit[index].ans_id >= 0 && dataSubmit[index].ans_id.length !== 0)) || (((fData.type === 'Writing' || fData.type === 'Speaking') && dataSubmit[index].answer !== '' && dataSubmit[index].answer !== 'noAnswer') || (fData.type === 'Writing' && fileSubmit[index] !== null) || (fData.type === 'Speaking' && audioUpload[index] !== '')) ? 'q_selected' : ''"
                                            v-if="isAll === false && isSpeak === true && fData.type === 'Speaking'"
                                                >
                                            {{ index + 1 }}
                                        </span> -->
                                        <!-- End khi chon Nói thì hiện cái này -->

                                        <!-- khi chon Đọc thì hiện cái này -->
                                        <!-- <span
                                            v-for="(fData, index) in dataRes.question"
                                            v-bind:key="fData.id"
                                            @click="scrollToElement(index)"
                                            :id="'q' + index"
                                            :class="(fData.type !== 'Writing' && fData.type !== 'Speaking' && (dataSubmit[index].ans_id >= 0 && dataSubmit[index].ans_id.length !== 0)) || (((fData.type === 'Writing' || fData.type === 'Speaking') && dataSubmit[index].answer !== '' && dataSubmit[index].answer !== 'noAnswer') || (fData.type === 'Writing' && fileSubmit[index] !== null) || (fData.type === 'Speaking' && audioUpload[index] !== '')) ? 'q_selected' : ''"
                                            v-if="isAll === false && isRead === true && fData.type === 'Reading'"
                                                >
                                            {{ index + 1 }}
                                        </span> -->
                                        <!-- End khi chon Đọc thì hiện cái này -->

                                        <!-- khi chon Viết thì hiện cái này -->
                                        <!-- <span
                                            v-for="(fData, index) in dataRes.question"
                                            v-bind:key="fData.id"
                                            @click="scrollToElement(index)"
                                            :id="'q' + index"
                                            :class="(fData.type !== 'Writing' && fData.type !== 'Speaking' && (dataSubmit[index].ans_id >= 0 && dataSubmit[index].ans_id.length !== 0)) || (((fData.type === 'Writing' || fData.type === 'Speaking') && dataSubmit[index].answer !== '' && dataSubmit[index].answer !== 'noAnswer') || (fData.type === 'Writing' && fileSubmit[index] !== null) || (fData.type === 'Speaking' && audioUpload[index] !== '')) ? 'q_selected' : ''"
                                            v-if="isAll === false && isWri === true && fData.type === 'Writing'"
                                                >
                                            {{ index + 1 }}
                                        </span> -->
                                        <!-- End khi chon Viết thì hiện cái này -->
                                    </div>
                                    <div class="d-flex flex-wrap align-items-center justify-content-between" style="padding: 15px; color: #6674BB !important; font-weight: 600;">
                                        <div style="width: 75%; position: relative;">
                                            <b-badge class="card-bar"></b-badge>
                                            <b-badge
                                                class="card-bar card-bar__value bg-2"
                                                :style="{ width: (totalQuestionSelected / totalQuestion) * 100 + '%' }"
                                            />
                                        </div>
                                        <div><span class="total-ques-selected" v-html="totalQuestionSelected"></span>/{{ totalQuestion }}</div>
                                    </div>

                                    <div class="text-right">

                                        <b-button
                                            variant="primary"
                                            @click="handleShowTableQuestions"
                                            class="ml-2 d-inline-block d-lg-none"
                                        >{{ $t("exam_student_result.button.close") }}
                                        </b-button>
                                    </div>

                                </div>
                            </div>

                            <div
                                class="d-flex justify-content-end containerTryExam p-0"
                                style="margin-bottom:20px; margin-top:20px;margin-right: auto; margin-left: auto"
                            >
                                <b-button
                                    variant="danger"
                                    @click="handleClose"
                                    class="mr-2"
                                    v-if="showingAnswer === false"
                                >{{ $t("exam_student_result.button.cancel") }}</b-button
                                >
                                <!-- Popup xác nhận nộp bài-->
                                <b-button
                                    variant="primary"
                                    @click="showSubmitPopup = true"
                                    v-if="showingAnswer === false"
                                >{{ $t("exam_student_result.button.submit") }}</b-button
                                >
                                <b-button
                                    variant="primary"
                                    @click="handleClose"
                                    v-if="showingAnswer === true"
                                >{{ $t("exam_student_result.button.close") }}
                                </b-button>

                                <b-button
                                    variant="primary"
                                    @click="handleShowTableQuestions"
                                    class="ml-2 d-block d-lg-none"
                                >{{ $t("exam_student_result.button.tableQuestions") }}
                                </b-button>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Contents Tab phan tich chuyen sau -->
                <div class="row col-12  fsize-18 color-black p-0 analysis-advance"
                     :class="(isAnalysisDetail ? 'd-flex' : 'd-none')"
                     v-if="isAnalysisDetail === true && showingAnswer === true"
                >
                    <div class="col-12 col-lg-8 px-0">
                        <div class="area-overview mb-5">
                            <p class="tt fsize-30 color-1 fw-500">{{ $t("tryExam.overview") }}</p>
                            <p class="tt-sub fsize-15">{{ $t("tryExam.text_1_overview") }}</p>
                            <div class="analysis-detaile">
                                <div class="group group-1" :class="{act : showTypeListenForMobile}" data-title="Tags Listening">
                                    <div class="item"
                                         v-for="(qTag, index) in questionTypeTagListening"
                                         :key="qTag.tags_id"

                                    >
                                        <p class="fsize-15 color-2">{{ locale === 'vi' ? listTags[qTag.tags_id][0].name : listTags[qTag.tags_id][0].name_ko ? listTags[qTag.tags_id][0].name_ko : listTags[qTag.tags_id][0].name }}</p>
                                        <p class="text-right fsize-13">{{ qTag.total_correct }}/{{ qTag.total_of_tags_id }}</p>
                                        <div class="card-chart col">
                                            <span class="badge card-bar badge-secondary"></span>
                                            <span class="badge card-bar card-bar__value badge-secondary"
                                                  :class="qTag.percent < 50 ? 'bg-required' : 'bg-1' "
                                                  :style="{ width: qTag.percent + '%' }"
                                            ></span>
                                        </div>
                                    </div>
                                    <div class="no-data-question-type"
                                         v-if="questionTypeTagListening.length === 0"
                                    >
                                        <p>{{ $t("tryExam.text_2_overview") }}</p>
                                    </div>
                                </div>
                                <div class="group group-2" :class="{act : showTypeReadForMobile}" data-title="Tags Reading">
                                    <div class="item"
                                         v-for="(qTag, index) in questionTypeTagReading"
                                         :key="qTag.tags_id"

                                    >
                                        <p class="fsize-15 color-2">{{ getNameTags(qTag.tags_id) }}</p>
                                        <p class="text-right fsize-13">{{ qTag.total_correct }}/{{ qTag.total_of_tags_id }}</p>
                                        <div class="card-chart col">
                                            <span class="badge card-bar badge-secondary"></span>
                                            <span class="badge card-bar card-bar__value badge-secondary"
                                                  :class="qTag.percent < 50 ? 'bg-required' : 'bg-1' "
                                                  :style="{ width: qTag.percent + '%' }"
                                            ></span>
                                        </div>
                                    </div>

                                    <div class="no-data-question-type"
                                         v-if="questionTypeTagReading.length === 0"
                                    >
                                        <p>{{ $t("tryExam.text_2_overview") }}</p>
                                    </div>
                                </div>
                                <div class="group group-3" :class="{act : showTypeSpeakForMobile}" data-title="Tags Speaking">
                                    <div class="item"
                                         v-for="(qTag, index) in questionTypeTagSpeaking"
                                         :key="qTag.tags_id"
                                         v-if="dataAnalysis.submit_status === 0"
                                    >
                                        <p class="fsize-15 color-2">{{  getNameTags(qTag.tags_id) }}</p>
                                        <p class="text-right fsize-13">{{ qTag.total_score }}/{{ qTag.max_score_of_tags }}</p>
                                        <div class="card-chart col">
                                            <span class="badge card-bar badge-secondary"></span>
                                            <span class="badge card-bar card-bar__value badge-secondary"
                                                  :class="qTag.percent < 50 ? 'bg-required' : 'bg-1'"
                                                  :style="{ width: qTag.percent + '%' }"
                                            ></span>
                                        </div>
                                    </div>

                                    <div class="no-data-question-type"
                                         v-if="questionTypeTagSpeaking.length === 0"
                                    >
                                        <p>{{ $t("tryExam.text_2_overview") }}</p>
                                    </div>

                                    <div class="no-data-question-type"
                                         v-if="dataAnalysis.submit_status !== 0 && questionTypeTagWriting.length > 0"
                                    >
                                        <p>{{ $t("tryExam.text_3_overview") }}</p>
                                    </div>
                                </div>
                                <div class="group group-4" :class="{act : showTypeWriteForMobile}" data-title="Tags Writing">
                                    <div class="item"
                                         v-for="(qTag, index) in questionTypeTagWriting"
                                         :key="qTag.tags_id"
                                         v-if="dataAnalysis.submit_status === 0"

                                    >
                                        <p class="fsize-15 color-2">{{ getNameTags(qTag.tags_id) }}</p>
                                        <p class="text-right fsize-13">{{ qTag.total_score }}/{{ qTag.max_score_of_tags }}</p>
                                        <div class="card-chart col">
                                            <span class="badge card-bar badge-secondary"></span>
                                            <span class="badge card-bar card-bar__value badge-secondary"
                                                  :class="qTag.percent < 50 ? 'bg-required' : 'bg-1' "
                                                  :style="{ width: qTag.percent + '%' }"
                                            ></span>
                                        </div>
                                    </div>

                                    <div class="no-data-question-type"
                                         v-if="questionTypeTagWriting.length === 0"
                                    >
                                        <p>{{ $t("tryExam.text_2_overview") }}</p>
                                    </div>

                                    <div class="no-data-question-type"
                                         v-if="dataAnalysis.submit_status !== 0 && questionTypeTagWriting.length > 0"
                                    >
                                        <p>{{ $t("tryExam.text_3_overview") }}</p>
                                    </div>
                                </div>
                                <div class="tab-button">
                                    <div class="b-listen">
                                        <span :class="{act : showTypeListenForMobile}" data-name="Listening" @click="showTypeForMobile">{{ $t("tryExam.listen") }}</span>
                                    </div>
                                    <div class="b-read">
                                        <span :class="{act : showTypeReadForMobile}" data-name="Reading" @click="showTypeForMobile">{{ $t("tryExam.read") }}</span>
                                    </div>
                                    <div class="b-speak">
                                        <span :class="{act : showTypeSpeakForMobile}" data-name="Speaking" @click="showTypeForMobile">{{ $t("tryExam.speak") }}</span>
                                    </div>
                                    <div class="b-write">
                                        <span :class="{act : showTypeWriteForMobile}" data-name="Writing" @click="showTypeForMobile">{{ $t("tryExam.write") }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="note fsize-15 color-3">
                                <p class="" style="text-decoration: underline;">{{ $t("tryExam.note") }}</p>
                                <ul class="">
                                    <li><i>{{ $t("tryExam.text_note_1") }}</i></li>
                                    <li><i>{{ $t("tryExam.text_note_2") }}</i></li>
                                </ul>
                            </div>
                        </div>

                        <div class="area-analysis-score">
                            <p class="tt fsize-30 color-1 fw-500">{{ $t("tryExam.analysis_score") }}</p>
                            <div class="level-topik">
                                <p class="t-list fsize-18 fw-500">{{ $t("tryExam.text_score_1") }}</p>
                                <div class="my-4 d-flex align-items-center flex-column-reverse flex-lg-row">
                                    <div class="col-12 col-md-9 fsize-18 color-4">
                                        <div v-if="dataAnalysis.topik_level && dataAnalysis.topik_level.length > 0">
                                            {{ $t("tryExam.text_score_3") }} <span style="display: inline; margin-left: -23px;" class="fsize-20 color-5 fw-500 pl-4">{{ dataAnalysis.topik_level }}</span>. {{ $t("tryExam.text_score_3_1") }}
                                        </div>
                                        <div v-else class="pl-4">
                                            {{ $t("tryExam.text_score_2") }}
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-3 fsize-24 fw-300" v-if="dataAnalysis.topik_level && dataAnalysis.topik_level.length > 0">
                                        <div class="kq">
                                            <p><span class="fw-600 color-5" :class="handleTopikLevel(dataAnalysis.topik_level)[0].length > 8 ? 'fsize-22' : 'fsize-32' ">{{handleTopikLevel(dataAnalysis.topik_level) ? handleTopikLevel(dataAnalysis.topik_level)[0] : '' }}</span><br /> {{handleTopikLevel(dataAnalysis.topik_level) ? handleTopikLevel(dataAnalysis.topik_level)[1] : '' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="compare-score">
                                <p class="t-list fsize-18 fw-500">{{ $t("tryExam.text_score_4") }}</p>
                                <div v-if="dataAnalysis.increase_score != 0">
                                    <p class="fsize-18 color-4">{{ $t("tryExam.text_score_5_1") }}  {{ dataAnalysis.increase_score > 0 ?  $t("tryExam.increase") : $t("tryExam.reduce") }} <span class="color-6 fw-600">{{ Math.abs(dataAnalysis.increase_score) }}</span> {{ $t("tryExam.text_score_5_2") }}</p>
                                </div>
                                <div v-else>
                                    <p class="fsize-18 color-4">{{ $t("tryExam.text_score_6") }}</p>
                                </div>
                            </div>
                            <div class="compare-all-student" v-if="dataAnalysis.total_user > 1">
                                <p class="t-list fsize-18 fw-500">{{ $t("tryExam.text_score_7") }}</p>
                                <div class="my-3 d-flex justify-content-end" v-if="dataAnalysis.user_score_level">
                                    <div class="col-12 col-md-7">
                                        <div class="text">
                                            <!-- <p class="t-1">{{ $t("tryExam.text_score_11_1") }} <span class="fw-600 color-7">{{ dataAnalysis.user_score_level }}</span> {{ $t("tryExam.text_score_11_2") }} <span class="fw-500 color-black">{{ dataAnalysis.total_user }}</span> {{ $t("tryExam.text_score_11_3") }}</p> -->
                                            <p class="t-1" v-html="$t(`tryExam.text_score_11`, {number_1: `<span class='fw-600 color-7'>`+ dataAnalysis.user_score_level + `</span>`, number_2: `<span class='fw-500 color-black'>`+ dataAnalysis.total_user +`</span>`})"></p>
                                            <p class="t-2">{{ dataAnalysis.user_score_level }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="chart-score-all-student">
                                    <div class="chart-score"
                                         v-if="isAnalysisDetail"
                                    >
                                        <Chart :data="dataChart" :user_score_seq="dataUserScoreSeq"/>
                                        <span class="y">%</span>
                                        <span class="x">{{ $t("tryExam.score") }}</span>
                                    </div>

                                    <div class="des-chart fsize-16">

                                        <span>{{ $t("tryExam.score_min") }}</span>
                                        <span>{{ $t("tryExam.score_of_you") }}</span>
                                        <span>{{ $t("tryExam.score_max") }}</span>
                                    </div>
                                    <p class="fsize-16 color-4 mt-4" v-html="$t(`tryExam.text_score_10`, {number_1: `<span class='color-black fw-500'>` + dataAnalysis.total_user + `</span>`, number_2: `<span class='fw-600' style='color: #FE7E81;'>` + dataAnalysis.chart.user_percentage + `%</span>`})"></p>

                                </div>
                            </div>
                            <div class="compare-all-student" v-else>
                                <p class="t-list fsize-18 fw-500">{{ $t("tryExam.text_score_7") }}</p>
                                <div class="row col-12">
                                    <div class="color-4 mt-4 pl-4">{{ $t("tryExam.text_score_12") }}</div>

                                </div>

                            </div>
                        </div>
                        <div class="solution-consulting mt-4">
                            <p class="tt fsize-30 color-1 fw-500">{{ $t("tryExam.consult_solution") }}</p>
                            <!-- <p class="t-2 fsize-16 mb-4">Dựa theo kết quả bạn đã đạt được trong bài kiểm tra này, chúng tôi có những đánh giá và đề xuất như sau:</p> -->
                            <div class="ml-5 control-t mb-4 d-none d-lg-block">
                                <span data-name="Listening" @click="typeClick" :class="{act : typeListen}">{{ $t("tryExam.listen") }}</span>
                                <span data-name="Speaking" @click="typeClick" :class="{act : typeSpeak}">{{ $t("tryExam.speak") }}</span>
                                <span data-name="Reading" @click="typeClick" :class="{act : typeRead}">{{ $t("tryExam.read") }}</span>
                                <span data-name="Writing" @click="typeClick" :class="{act : typeWrite}">{{ $t("tryExam.write") }}</span>
                            </div>
                            <p class="t-3 fsize-16 d-block d-lg-none mb-3"
                               v-html="$t(`tryExam.text_solution_1`,{text: ``, class: `d-none`})"
                            ></p>

                            <p class="t-3 fsize-16 d-none d-lg-block "
                               v-if="(questionTypeTagListening.length > 0 && typeListen) || (questionTypeTagSpeaking.length > 0 && typeSpeak) || (questionTypeTagReading.length > 0 && typeRead) || (questionTypeTagWriting.length > 0 && typeWrite)"
                               v-html="$t(`tryExam.text_solution_1`,{text: typeListen ? $t(`tryExam.listen`) : typeSpeak ? $t(`tryExam.speak`) : typeRead ? $t(`tryExam.read`) : typeWrite ? $t(`tryExam.write`) : '', class: ``})"
                            ></p>

                            <div class="skills-need-advance"
                                 v-show="(questionTypeTagListening.length > 0 && typeListen) || (questionTypeTagSpeaking.length > 0 && typeSpeak) || (questionTypeTagReading.length > 0 && typeRead) || (questionTypeTagWriting.length > 0 && typeWrite)"
                            >
                                <div class="bg">
                                    <div class="gr gr-1" :class="{act : typeListen}" :data-title="$t(`tryExam.listen`)"
                                         v-show="questionTypeTagListening.length > 0"
                                    >
                                        <div class="item"
                                             v-for="(qTag, index) in questionTypeTagListening"
                                             v-if="index < 3"
                                             :key="qTag.tags_id"
                                        >
                                            <p class="fsize-15 color-2">{{ getNameTags(qTag.tags_id) }}</p>
                                            <p class="text-right fsize-13">{{ qTag.total_correct }}/{{ qTag.total_of_tags_id }}</p>
                                            <div class="card-chart col">
                                                <span class="badge card-bar badge-secondary"></span>
                                                <span class="badge card-bar card-bar__value badge-secondary"
                                                      :class="qTag.percent < 50 ? 'bg-required' : 'bg-1' "
                                                      :style="{ width: qTag.percent + '%' }"
                                                ></span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="gr gr-2" :class="{act : typeSpeak}" :data-title="$t(`tryExam.speak`)"
                                         v-show="questionTypeTagSpeaking.length > 0"
                                    >
                                        <div class="item"
                                             v-for="(qTag, index) in questionTypeTagSpeaking"
                                             v-if="index < 3 && dataAnalysis.submit_status === 0"
                                             :key="qTag.tags_id"
                                        >
                                            <p class="fsize-15 color-2">{{ getNameTags(qTag.tags_id) }}</p>
                                            <p class="text-right fsize-13">{{ qTag.total_score }}/{{ qTag.max_score_of_tags }}</p>
                                            <div class="card-chart col">
                                                <span class="badge card-bar badge-secondary"></span>
                                                <span class="badge card-bar card-bar__value badge-secondary"
                                                      :class="qTag.percent < 50 ? 'bg-required' : 'bg-1' "
                                                      :style="{ width: qTag.percent + '%' }"
                                                ></span>
                                            </div>
                                        </div>
                                        <div class="text-center fsize-15 text-noti" v-if="dataAnalysis.submit_status !== 0">
                                            {{ $t("tryExam.text_solution_4") }}
                                        </div>
                                    </div>
                                    <!-- v-if="index < 3 && qTag.percent < 50" -->
                                    <div class="gr gr-3" :class="{act : typeRead}" :data-title="$t(`tryExam.read`)"
                                         v-show="questionTypeTagReading.length > 0"
                                    >
                                        <div class="item"
                                             v-for="(qTag, index) in questionTypeTagReading"
                                             v-if="index < 3"
                                             :key="qTag.tags_id"
                                        >
                                            <p class="fsize-15 color-2">{{ getNameTags(qTag.tags_id) }}</p>
                                            <p class="text-right fsize-13">{{ qTag.total_correct }}/{{ qTag.total_of_tags_id }}</p>
                                            <div class="card-chart col">
                                                <span class="badge card-bar badge-secondary"></span>
                                                <span class="badge card-bar card-bar__value badge-secondary"
                                                      :class="qTag.percent < 50 ? 'bg-required' : 'bg-1' "
                                                      :style="{ width: qTag.percent + '%' }"
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="gr gr-4" :class="{act : typeWrite}" :data-title="$t(`tryExam.write`)"
                                         v-show="questionTypeTagWriting.length > 0"
                                    >
                                        <div class="item"
                                             v-for="(qTag, index) in questionTypeTagWriting"
                                             v-if="index < 3 && dataAnalysis.submit_status === 0"
                                             :key="qTag.tags_id"
                                        >
                                            <p class="fsize-15 color-2">{{ getNameTags(qTag.tags_id) }}</p>
                                            <p class="text-right fsize-13">{{ qTag.total_score }}/{{ qTag.max_score_of_tags }}</p>
                                            <div class="card-chart col">
                                                <span class="badge card-bar badge-secondary"></span>
                                                <span class="badge card-bar card-bar__value badge-secondary"
                                                      :class="qTag.percent < 50 ? 'bg-required' : 'bg-1' "
                                                      :style="{ width: qTag.percent + '%' }"
                                                ></span>
                                            </div>
                                        </div>
                                        <div class="text-center fsize-15 text-noti" v-if="dataAnalysis.submit_status !== 0">
                                            {{ $t("tryExam.text_solution_4") }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 pl-0 pl-md-3 pr-0">
                        <div class="area-recommend">
                            <div class="control-t text-center my-2">
                                <span data-name="Listening" @click="typeClick" :class="{act : typeListen}">{{ $t("tryExam.listen") }}</span>
                                <span data-name="Speaking" @click="typeClick" :class="{act : typeSpeak}">{{ $t("tryExam.speak") }}</span>
                                <span data-name="Reading" @click="typeClick" :class="{act : typeRead}">{{ $t("tryExam.read") }}</span>
                                <span data-name="Writing" @click="typeClick" :class="{act : typeWrite}">{{ $t("tryExam.write") }}</span>
                            </div>
                            <div class="ar-gr">
                                <div class="course-recom">
                                    <p class="fsize-20 fw-600 text-center">{{ $t("tryExam.course_recommend") }}</p>
                                    <SlideCourse :data="dataCourse" :view="1" />
                                </div>
                                <div class="exam-recom">
                                    <p class="fsize-20 fw-600 text-center">{{ $t("tryExam.exam_recommend") }}</p>
                                    <SlideExam :data="dataExam" :view="1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Contents Tab phan tich chuyen sau -->
                <!-- Content slide -->
                <div class="row col-12 group-slides"
                     v-if="isAnalysisDetail === true && showingAnswer === true"
                >
                    <p class="t-4 fsize-16 mb-3"
                       v-html="$t(`tryExam.text_solution_2`,{text: typeListen ? $t(`tryExam.listen`) : typeSpeak ? $t(`tryExam.speak`) : typeRead ? $t(`tryExam.read`) : typeWrite ? $t(`tryExam.write`) : '', class: ``})"
                    ></p>
                    <SlideExam :data="dataExam" :view="4"
                               :breakpoints="{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                            slidesPerGroup: 1
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                            slidesPerGroup: 2
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            slidesPerGroup: 3
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                            slidesPerGroup: 4
                        },
                    }"/>
                    <p class="t-5 fsize-16 mb-3 mt-3"
                       v-html="$t(`tryExam.text_solution_3`,{text: typeListen ? $t(`tryExam.listen`) : typeSpeak ? $t(`tryExam.speak`) : typeRead ? $t(`tryExam.read`) : typeWrite ? $t(`tryExam.write`) : '', class: ``})"
                    ></p>
                    <SlideCourse :data="dataCourse" :view="4"
                                 :breakpoints="{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                            slidesPerGroup: 1
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                            slidesPerGroup: 2
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            slidesPerGroup: 3
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                            slidesPerGroup: 4
                        },
                    }" />
                </div>
                <!-- End slide -->
                <div class="text-right col-12 p-2"
                     v-if="isAnalysisDetail === true && showingAnswer === true"
                >
                    <b-button
                        variant="primary"
                        @click="handleClose"
                        v-if="showingAnswer === true"
                    >{{ $t("exam_student_result.button.close") }}
                    </b-button>
                </div>
            </div>
        </div>
        <!-- Thường: Popup hiển thị đầu tiên -->
        <div v-if="showPopupNormal" class="popup-overlay">
            <div class="popup">
                <div>
                    <div>
                        <h3>{{ dataRes.name }}</h3>
                    </div>
                </div>
                <p>{{ $t("tryExam.sha_vnu_lable6") }}: <span style="font-weight: bold; color: #7ACC00; font-size: 18px;">{{ this.dataRes.time / 60 }}</span> {{ $t("tryExam.sha_vnu_lable9") }}</p>
                <p>{{ $t("tryExam.sha_vnu_lable7") }} <span style="font-weight: bold; color: red; font-size: 18px;">{{ countdown }}</span> {{ $t("tryExam.sha_vnu_lable8") }}. {{ $t("tryExam.sha_vnu_lable10") }} <b>“🚀 {{ $t("tryExam.sha_vnu_lable11") }}”</b> {{ $t("tryExam.sha_vnu_lable12") }}.</p>
                <p>{{ $t("tryExam.sha_vnu_lable39") }}</p>
                <br>
                <button class="btn_popup btn-start-exam" @click="startNowNormal">🚀 {{ $t("tryExam.sha_vnu_lable11") }}</button>
            </div>
        </div>
        <!-- HSA: Popup hiển thị đầu tiên -->
        <div v-if="showPopup" class="popup-overlay">
            <div class="popup">
                <!--<div v-if="hsa_vnu_seq(this.exam_id) == 1">
                    <p style="text-align: left">{{ $t("tryExam.sha_vnu_lable1") }}</p>
                    <table class="exam-parts-table">
                        <tbody>
                        <tr>
                            <td>{{ $t("tryExam.sha_vnu_lable24") }}:</td>
                            <td>{{ $t("tryExam.sha_vnu_lable2") }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("tryExam.sha_vnu_lable25") }}:</td>
                            <td>{{ $t("tryExam.sha_vnu_lable3") }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("tryExam.sha_vnu_lable26") }}:</td>
                            <td>{{ $t("tryExam.sha_vnu_lable4") }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <p style="text-align: left">{{ $t("tryExam.sha_vnu_lable5") }}</p>
                    <br>
                </div>-->
                <div v-if="(hsa_vnu_seq(this.exam_id) == 1 || hsa_vnu_seq(this.exam_id) == 2)">
                    <div v-if="hsa_vnu_seq(this.exam_id) == 1">
                        <p style="font-weight: 600">({{ $t("tryExam.sha_vnu_lable24") }})</p>
                        <h3>{{ $t("tryExam.sha_vnu_lable2") }}</h3>
                    </div>
                    <div v-if="hsa_vnu_seq(this.exam_id) == 2">
                        <p style="font-weight: 600">({{ $t("tryExam.sha_vnu_lable25") }})</p>
                        <h3>{{ $t("tryExam.sha_vnu_lable3") }}</h3>
                    </div>
                </div>
                <div v-if="hsa_vnu_seq(this.exam_id) == 3">
                    <p style="font-weight: 600">({{ $t("tryExam.sha_vnu_lable26") }})</p>
                    <h3>{{ $t("tryExam.sha_vnu_lable4") }}</h3>
                    <div class="subject-radio-group">
                        <label class="subject-radio">
                            <input type="radio" value="english" v-model="selectedOption" />
                            {{ $t("tryExam.sha_vnu_lable19") }}
                        </label>
                        <label class="subject-radio">
                            <input type="radio" value="science" v-model="selectedOption" />
                            {{ $t("tryExam.sha_vnu_lable20") }}
                        </label>
                    </div>
                    <transition name="fade">
                        <div v-if="selectedOption === 'science'" class="subject-checkbox-group">
                            <p class="subject-note">{{ $t("tryExam.sha_vnu_lable21") }}:</p>
                            <div
                                v-for="subject in subjects"
                                :key="subject.value"
                                class="subject-checkbox"
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        :value="subject.value"
                                        v-model="selectedSubjects"
                                        :disabled="isDisabled(subject.value)"
                                    />
                                    {{ normalizeLabel(subject.label) }}
                                </label>
                            </div>
                        </div>
                    </transition>
                </div>
                <p>{{ $t("tryExam.sha_vnu_lable6") }}: <span style="font-weight: bold; color: #7ACC00; font-size: 18px;">{{ this.dataRes.time / 60 }}</span> {{ $t("tryExam.sha_vnu_lable9") }}</p>
                <p>{{ $t("tryExam.sha_vnu_lable7") }} <span style="font-weight: bold; color: red; font-size: 18px;">{{ countdown }}</span> {{ $t("tryExam.sha_vnu_lable8") }}. {{ $t("tryExam.sha_vnu_lable10") }} <b>“🚀 {{ $t("tryExam.sha_vnu_lable11") }}”</b> {{ $t("tryExam.sha_vnu_lable12") }}.</p>
                <br>
                <button v-if="(hsa_vnu_seq(this.exam_id) == 1 || hsa_vnu_seq(this.exam_id) == 2)" class="btn_popup" @click="startNow">🚀 {{ $t("tryExam.sha_vnu_lable11") }}</button>
                <button v-else class="btn_popup btn-start-exam" :disabled="!canStart" @click="startNow">🚀 {{ $t("tryExam.sha_vnu_lable11") }}</button>
            </div>
        </div>
        <!-- Popup xác nhận nộp bài -->
        <div v-if="showSubmitPopup" class="popup-overlay">
            <div class="popup_submit">
                <h3>{{ $t("tryExam.sha_vnu_lable13") }}</h3>
                <p>{{ $t("tryExam.sha_vnu_lable14") }} <span style="font-weight: bold; color: #6674BB !important; font-size: 18px;"> {{totalQuestionSelected}}/{{totalQuestion}} </span> {{ $t("tryExam.sha_vnu_lable15") }}.</p>
                <p>{{ $t("tryExam.sha_vnu_lable16") }}</p>
                <div class="btn-group">
                    <button class="btn-continue" @click="showSubmitPopup = false" v-if="totalQuestionSelected != totalQuestion">📝 {{ $t("tryExam.sha_vnu_lable17") }}</button>
                    <button class="btn-submit" @click="submitExam">✅ {{ $t("tryExam.sha_vnu_lable18") }}</button>
                </div>
            </div>
        </div>
        <!-- 🔹 Popup 3: Kết quả bài thi HSA VNU -->
        <div v-if="showResultPopup" class="popup-overlay result-overlay">
            <div class="popup-result-box">
                <h2 class="result-title">{{ $t("tryExam.sha_vnu_lable27") }}</h2>
                <p class="result-line"><strong>{{ $t("tryExam.sha_vnu_lable28") }}:</strong> {{ this.examResult.userFullname }}</p>
                <p class="result-line"><strong>{{ $t("tryExam.sha_vnu_lable29") }}:</strong> {{ toDay }}</p>
                <!--<p class="result-line"><strong>{{ $t("tryExam.sha_vnu_lable35") }}:</strong> {{ this.dataRes.time_to_play_of_student }}</p>-->
                <table class="result-table">
                    <thead>
                    <tr>
                        <th>{{ $t("tryExam.sha_vnu_lable30") }}</th>
                        <th>{{ $t("tryExam.sha_vnu_lable31") }}</th>
                        <th>{{ $t("tryExam.sha_vnu_lable32") }}</th>
                        <th>
                            <span v-if="this.selectedOption === 'english'">
                                {{ $t("tryExam.sha_vnu_lable19") }}
                            </span>
                            <span v-else-if="this.selectedOption === 'science'">
                                {{ $t("tryExam.sha_vnu_lable20") }}
                            </span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><span style="font-weight: bold; color: red; font-size: 20px;">{{ this.examResult.totalScore }}</span></td>
                        <td><span style="color: red; font-size: 18px;">{{ this.examResult.qualitativeScore }}</span></td>
                        <td><span style="color: red; font-size: 18px;">{{ this.examResult.quantitativeScore }}</span></td>
                        <td><span style="color: red; font-size: 18px;">{{ this.examResult.englishScore }}</span></td>
                    </tr>
                    <!--<tr>
                        <td></td>
                        <td>
                            <a href="javascript:void(0)" @click="handleViewResult1">
                                {{ $t("tryExam.sha_vnu_lable33") }}
                            </a>
                        </td>
                        <td>
                            <a href="javascript:void(0)" @click="handleViewResult2">
                                {{ $t("tryExam.sha_vnu_lable33") }}
                            </a>
                        </td>
                        <td>
                            <a href="javascript:void(0)" @click="handleViewResult3">
                                {{ $t("tryExam.sha_vnu_lable33") }}
                            </a>
                        </td>
                    </tr>-->
                    </tbody>
                </table>
                <button class="btn_popup btn-start-exam" @click="closeResultPopup">{{ $t("tryExam.sha_vnu_lable34") }}</button>
            </div>
        </div>
        <!-- 🔹 Popup 4: chặn mở tab khác để tra kết quả bài làm -->
        <div v-if="examWarningVisible" class="popup-overlay">
            <div class="popup_submit">
                <p>{{ $t("exam_student_result.button.confMesg") }}</p>
                <div class="btn-group">
                    <button class="btn-continue" style="color: #ffffff; background-color: #dc3545; border-color: #dc3545;" @click="stopExam">⛔ {{ $t("exam_student_result.button.confStopExam") }}</button>
                    <button class="btn-continue" @click="continueExam">📝 {{ $t("exam_student_result.button.confContinueExam") }}</button>
                </div>
            </div>
        </div>
    </a-spin>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment/moment";
import Cookies from "js-cookie";
import router from "@/router";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

import SlideExam  from  "../ExamStudent/SlideExam.vue";
import SlideCourse  from  "../ExamStudent/SlideCourse.vue";

//import Chart from "./Chart.vue";
import Chart from "../ExamStudent/Chart.vue";

import Recorder from "../../components/recorder/Recorder.vue";

import Screenshot from "../../components/screenshotpage/Screenshot.vue";

export default {
    components: {SlideExam, SlideCourse, Chart, Recorder, Screenshot},
    data() {
        return {
            showPopupNormal: false,
            examStarted: false,
            examWarningVisible: false,
            handlingFullscreenResume: false,

            exam_id: "",

            editor: DecoupledEditor,
            editorConfig: {
                toolbar: ["bold", "italic", "underline"]
            },
            timeDuration: null,
            isLoading: false,
            nameInputFile: "",
            inputFile_path_notVuex: "",
            dataRes: [],
            timeDoExam: null,
            interval: undefined,
            dataSubmit:[],
            fileSubmit: [],
            checkboxSub: [],
            keyInput: 0,
            answerRes: [],
            showingAnswer: false,
            showExplain: [],
            showModal: [],
            toDay: null,
            typeExam: null,
            duration: null,
            timeOut: "",
            totalQuestionSelected: 0,

            isAll: true,
            isListen: true,
            isSpeak: true,
            isRead: true,
            isWri: true,
            showTableQuestions: false,
            isAnalysisDetail: false,
            isAnswerDetail: true,

            questionTypeTags: [],
            listTags: '',
            dataAnalysis: '',
            dataExam: [],
            dataCourse: [],
            dataChart: null,
            dataUserScoreSeq: null,

            exam_actual_time: 0,

            showTypeListenForMobile: true,
            showTypeReadForMobile: false,
            showTypeSpeakForMobile: false,
            showTypeWriteForMobile: false,

            totalQuestion : 0,

            tQListen: 0,
            tQSpeak: 0,
            tQRead: 0,
            tQWrit: 0,

            correctListen: 0,
            correctSpeak: 0,
            correctRead: 0,
            correctWrit: 0,
            audioUpload: [],
            upload_audio_input: [],
            form: {
                title: "",
                type: "Listening",
                status: "Active",
                score: "",
                difficulty: "Easy",
                category: [],
                explain: "explain",
                image_path: "",
                video_path: "",
                embed_image_video: "",
                audio_path: [],
                embed_audio: "",
                answer_option: "One choice",
                answer: [],
                image: [],
                answer_text: [],
                number_answer: 4
            },

            typeListen: true,
            typeRead: false,
            typeSpeak: false,
            typeWrite:false,

            startRecord: [],
            currentAudioPlaying: null,
            showLessTextClick: [],
            group_audios: ['audios-question', 'audios-reply', 'audios-answer'],

            // Lưu câu trả lời người dùng
            userInput: [],

            // begin: hsa vnu for sangsang
            showPopup: false,
            countdown: 120,
            countdownTimer: null,
            confirmPromiseResolve: null,
            showSubmitPopup: false,
            selectedOption: 'english',
            selectedSubjects: [],
            subjects: [
                { label: "Vật lý", value: "physics" },
                { label: "Hóa học", value: "chemistry" },
                { label: "Sinh học", value: "biology" },
                { label: "Lịch sử", value: "history" },
                { label: "Địa lý", value: "geography" },
            ],
            showResultPopup: false,
            exam_id1: "",
            exam_name1: "",
            exam_id2: "",
            exam_name2: "",
            exam_id3: "",
            exam_name3: "",
            candidateName: "",
            examDate: "",
            examResult: {},
            showScienceBlock: false,
            index_seq: 0,

            showWaitPopup: false,     // hiện popup hay không
            waitSeconds: 0,           // số giây còn lại để đợi
            waitSecondsInitial: 0,    // tổng số giây ban đầu (dùng tính %)
            progress: 100,            // % thanh progress bar
            _waitInterval: null
        };
    },
    computed: {
        ...mapGetters({
            user: "auth/user",
            infoExamRes: "exam/examInfoRes",
            detailResultExam: "student/detailResultExam",
            locale: "lang/locale",
            infoHSAVNU: "exam/topicInfoRes",

        }),
        ...mapState("question", ["changeListTags"]),
        ...mapState("exam", ["dataAnalysisExam"]),
        ...mapState("exam", ["newScienceExam"]),
        ...mapState("exam", ["hsaExamResults"]),

        questionTypeTagReading: function(){
            return this.questionTypeTags.filter(i=>i.type === "Reading");
        },
        questionTypeTagListening: function(){
            return this.questionTypeTags.filter(i=>i.type === "Listening");
        },
        questionTypeTagWriting: function(){
            return this.questionTypeTags.filter(i=>i.type === "Writing");
        },
        questionTypeTagSpeaking: function(){
            return this.questionTypeTags.filter(i=>i.type === "Speaking");
        },
        canStart() {
            if (this.selectedOption === "english") return true;
            if (this.selectedOption === "science" && this.selectedSubjects.length === 3)
                return true;
            return false;
        },



    },
    async created() {
        this.isLoading = true;
        this.typeExam = Cookies.get("typeExam");
        this.toDay = moment().format("DD/MM/YYYY");
        let pairs = window.location.search.substring(1).split("&")
        this.exam_id = pairs && pairs[0] !== undefined ? pairs[0] : 0;

        //await this.$store.dispatch("question/changeListTags", {type: 'all'}); // lay data tu api
        //this.listTags = this.groupBy(this.changeListTags.data,'id');

        await this.$store.dispatch("exam/getInfoExam", this.exam_id);
        if (this.$store.state.exam.examInfoRes.status === 200) {
            this.dataRes = JSON.parse(this.infoExamRes[0]);
            this.dataRes.time = this.dataRes.time * 60;
            this.timeDuration = this.dataRes.time;
            this.listTags = this.groupBy(this.dataRes.tags,'id');

            this.totalQuestion = this.dataRes.question.length;
            this.questionTypeTags = this.handleTypeTags(this.dataRes.question);
            if (
                Cookies.get("typeExam") !== "result" &&
                this.dataRes.time_to_play_of_student >= this.dataRes.time_to_play
            ) {
                this.$root.toast(
                    this.$t("msg.E_UC6_20"),
                    "danger",
                    this.$t("msg.E_UC6_21")
                );
                this.handleClose();
                return;
            }
            if (this.dataRes) {
                this.timeDoExam = this.dataRes.time;
            }
            /*if (Cookies.get("typeExam") !== "result") {
                await this.countTime();
            }*/
            /*---------------------------------------*/
            // tiemtt <tiemtt@gmail.com>
            if(this.dataRes
                && this.dataRes.question_id
                && this.dataRes.question
                && this.dataRes.question_id.length > 0 && this.dataRes.question.length > 0) {
                let temp_draft = [];
                this.dataRes.question_id.forEach((idExam, i) => {
                    if (idExam) {
                        for (let i = 0; i < this.dataRes.question.length; i++) {
                            if (this.dataRes.question[i]) {
                                if (this.dataRes.question[i].id == idExam) {
                                    temp_draft.push(this.dataRes.question[i]);
                                    break;
                                }
                            }
                        }
                    }
                });
                this.dataRes.question = temp_draft;
            }
            /*---------------------------------------*/
            for (let i = 0; i < this.dataRes.question.length; i++) {
                this.fileSubmit[i] = null;
                this.showExplain[i] = true;
                this.showModal[i] = false;
                this.audioUpload[i] = '';
                if (this.dataRes.question[i].type !== "Writing" && this.dataRes.question[i].type !== "Speaking") {
                    this.dataSubmit.push({
                        type: this.dataRes.question[i].type,
                        ans_id: [],
                        question_id: this.dataRes.question[i].id,
                        //   ans_correct_value: this.dataRes.question[i].answer[0].ans_value,
                        answer_value: ""
                    });
                } else {
                    this.dataSubmit.push({
                        type: this.dataRes.question[i].type,
                        answer: "",
                        question_id: this.dataRes.question[i].id,
                    });
                }
                // lấy tổng số câu hỏi của mỗi loại
                if (this.dataRes.question[i].type === "Listening") {
                    this.tQListen++;
                } else if (this.dataRes.question[i].type === "Reading") {
                    this.tQRead++;
                } else if (this.dataRes.question[i].type === "Speaking") {
                    this.tQSpeak++;
                } else if (this.dataRes.question[i].type === "Writing") {
                    this.tQWrit++;
                }
            }
        } else {
            this.$root.toast(
                this.$t("examStudent.toast.error"),
                "danger",
                this.$t(`msg["E_UC6_3"]`)
            );
            if (!(this.user && this.user.business_id)) {
                router.push("/student/exam/my-exam");
            }
        }
        if (Cookies.get("typeExam") === "result") {
            this.$store
                .dispatch("student/getDetailResultExam", {
                    id_submit: Cookies.get("idResultExam")
                })
                .then(() => {
                    this.answerRes = this.detailResultExam;
                    this.duration = this.detailResultExam[0].duration;
                    this.showingAnswer = true;
                    this.handleShowAnswer();
                    this.handleCheckStatus();
                    if (!(this.user && this.user.business_id)) {
                        this.apiDataChartCourseExam();
                    }
                    this.exam_actual_time = this.duration;
                });
        }
        this.isLoading = false;
        // đây có phải bài thi hsa của vnu không?
        if (this.dataRes && this.dataRes.hsavnu) {
            Cookies.set("hsavnu_id_1", this.dataRes.hsavnu.exam_id_1, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});
            Cookies.set("hsavnu_name_1", this.dataRes.hsavnu.exam_name_1, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});
            Cookies.set("hsavnu_total_question_1", this.dataRes.hsavnu.exam_total_question_1, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});

            Cookies.set("hsavnu_id_2", this.dataRes.hsavnu.exam_id_2, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});
            Cookies.set("hsavnu_name_2", this.dataRes.hsavnu.exam_name_2, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});
            Cookies.set("hsavnu_total_question_2", this.dataRes.hsavnu.exam_total_question_2, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});

            Cookies.set("hsavnu_id_3", this.dataRes.hsavnu.exam_id_3, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});
            Cookies.set("hsavnu_name_3", this.dataRes.hsavnu.exam_name_3, {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});
            Cookies.set("hsavnu_option_science_3", "", {expires: Number(this.dataRes.hsavnu.total_time) / (60 * 24)});
        } else {
            // nếu bài thi ko thuộc 1 trong các bài HSA thì xoá
            const examId1 = Number(Cookies.get("hsavnu_id_1") ?? 0);
            const examId2 = Number(Cookies.get("hsavnu_id_2") ?? 0);
            const examId3 = Number(Cookies.get("hsavnu_id_3") ?? 0);

            const cookieExamIds = [examId1, examId2, examId3];

            if (!cookieExamIds.includes(Number(this.exam_id))) {
                // Nếu exam hiện tại KHÔNG thuộc 3 cookie → xoá cookie
                Cookies.remove("hsavnu_id_1");
                Cookies.remove("hsavnu_name_1");
                Cookies.remove("hsavnu_total_question_1");

                Cookies.remove("hsavnu_id_2");
                Cookies.remove("hsavnu_name_2");
                Cookies.remove("hsavnu_total_question_2");

                Cookies.remove("hsavnu_id_3");
                Cookies.remove("hsavnu_name_3");
                Cookies.remove("hsavnu_option_science_3");
            }
        }
        // mở popup thông báo trước khi làm bài thi
        if (Cookies.get("hsavnu_id_1") && (Cookies.get("hsavnu_id_1") == this.exam_id || Cookies.get("hsavnu_id_2") == this.exam_id || Cookies.get("hsavnu_id_3") == this.exam_id)) {
            if (Cookies.get("hsavnu_id_3") == this.exam_id && Cookies.get("hsavnu_option_science_3") === "science") {
                this.showScienceBlock = true;
                await this.countTime();
            } else {
                if (Cookies.get("typeExam") !== "result") {
                    const confirmed = await this.waitForUserStart();
                    if (confirmed) {
                        await this.countTime();
                    }
                } else {
                    Cookies.remove("typeExam");
                }
            }
            // xử lý index câu hỏi hsa
            if (Cookies.get("hsavnu_id_2") == this.exam_id) {
                this.index_seq = Number(Cookies.get("hsavnu_total_question_1"));
            } else if (Cookies.get("hsavnu_id_3") == this.exam_id) {
                this.index_seq = Number(Cookies.get("hsavnu_total_question_1")) + Number(Cookies.get("hsavnu_total_question_2"));
            }
        } else {
            if (Cookies.get("typeExam") !== "result") {
                const confirmed = await this.waitForUserStartNormal();
                if (confirmed) {
                    this.startNowNormal();
                }
            }
        }
        // end: popup
    },
    updated() {
        if (this.showingAnswer === false) {
            let totalQuesSelect = document.getElementsByClassName('q_selected').length;
            this.totalQuestionSelected = totalQuesSelect;
        }
    },
    mounted() {
        // mở popup xử lý fullscreen khi làm bài (tránh việc mở tab khác tra kết quả)
        //this.startExam();
        //document.addEventListener("fullscreenchange", this.handleFullscreenChange);

        // chặn ko cho người dùng mở thông qua F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
        function ctrlShiftKey(e, keyCode) {
            return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
        }

        document.onkeydown = (e) => {
            if (
                e.keyCode === 123 ||
                ctrlShiftKey(e, 'I') ||
                ctrlShiftKey(e, 'J') ||
                ctrlShiftKey(e, 'C') ||
                (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
            )
                return false;
        };
        // Chặn bôi đen văn bản
        addEventListener("selectstart", event => event.preventDefault());
    },
    methods: {
        // *** for Fullscreen ***
        async startExam() {
            try {
                const el = document.getElementById("exam-container-trying");

                if (!el) {
                    console.error("Không tìm thấy examContainer");
                    return;
                }

                if (el.requestFullscreen && Cookies.get("typeExam") !== "result") {
                    await el.requestFullscreen();
                }

                this.examStarted = true;
            } catch (err) {
                console.error("Fullscreen error:", err);
            }
        },
        // *** for Fullscreen ***
        handleFullscreenChange() {
            if (!this.examStarted) return;

            // Nếu đang trong quá trình resume fullscreen thì bỏ qua
            if (this.handlingFullscreenResume) {
                this.handlingFullscreenResume = false;
                return;
            }

            // User đã thoát fullscreen (ví dụ nhấn ESC)
            if (!document.fullscreenElement) {
                this.openExamWarning();
            }
        },
        // *** for Fullscreen ***
        openExamWarning() {
            if (this.examWarningVisible) return;
            this.examWarningVisible = true;
        },
        // *** for Fullscreen ***
        async continueExam() {
            this.examWarningVisible = false;

            try {
                const el = document.getElementById("exam-container-trying");

                if (!el) {
                    console.error("Không tìm thấy examContainer");
                    return;
                }

                this.handlingFullscreenResume = true;

                if (!document.fullscreenElement && el.requestFullscreen) {
                    await el.requestFullscreen();
                }
            } catch (err) {
                this.handlingFullscreenResume = false;
                console.error("Continue exam fullscreen error:", err);
            }
        },
        // *** for Fullscreen ***
        stopExam() {
            this.examWarningVisible = false;
            this.examStarted = false;
            this.handleClose();
        },
        // auto bật thông báo trước khi thi.
        async waitForUserStartNormal() {
            this.showPopupNormal = true;
            return new Promise((resolve) => {
                this.confirmPromiseResolve = resolve;
                this.startCountdown(); // Bắt đầu đếm ngược
            });
        },
        async startNowNormal() {
            this.showPopupNormal = false;
            await this.countTime();
            this.startExam();
            document.addEventListener("fullscreenchange", this.handleFullscreenChange);
        },
        // popup thông báo được mở ra trước khi bắt đầu bài thi
        async waitForUserStart() {
            this.showPopup = true;
            if (Cookies.get("hsavnu_id_3") && Cookies.get("hsavnu_id_3") == this.exam_id) {
                await this.$store.dispatch("exam/getHSATopics", Cookies.get("hsavnu_id_1"));
                if (this.$store.state.exam.topicInfoRes.status === 200) {
                    this.subjects = this.infoHSAVNU[0].map(topic => ({
                        label: topic.title,
                        value: topic.id
                    }));
                    if (this.subjects && this.subjects.length >= 3) {
                        this.selectedSubjects = this.subjects.slice(0, 3).map(s => s.value);
                    }
                }
            }
            return new Promise((resolve) => {
                this.confirmPromiseResolve = resolve;
                this.startCountdown(); // Bắt đầu đếm ngược
            });
        },
        startCountdown() {
            this.countdown = 180;
            this.countdownTimer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.autoStart();
                }
            }, 1000);
        },
        async startNow() {
            // nếu chọn thi Khoa Học thì khởi tạo bài thi Khoa Học
            if (Cookies.get("hsavnu_id_3") && Cookies.get("hsavnu_id_3") == this.exam_id && this.selectedOption === "science") {
                const selectedIds = this.selectedSubjects;
                if (selectedIds.length > 0) {
                    await this.$store.dispatch("exam/submitSelectedScience", {
                        exam_id1: Cookies.get("hsavnu_id_1"),
                        exam_id2: Cookies.get("hsavnu_id_2"),
                        exam_id3: Cookies.get("hsavnu_id_3"),
                        topic_ids: selectedIds
                    });
                    if (this.$store.state.exam.newScienceExam.status === 200) {
                        const new_res = this.newScienceExam.data;
                        if (new_res && new_res.exam_id) {
                            //console.log("tiemtt test2:", new_res);
                            //tắt popup lựa chọn
                            this.closePopup();
                            if (this.confirmPromiseResolve) this.confirmPromiseResolve(true);
                            // bắt đầu làm bài
                            Cookies.set("hsavnu_id_3", new_res.exam_id);
                            Cookies.set("hsavnu_option_science_3", 'science');
                            this.handleDoExam(new_res.exam_id, new_res.exam_name);
                        } else {
                            alert(this.$t("tryExam.sha_vnu_lable36"));
                        }
                    } else {
                        alert(this.$t("tryExam.sha_vnu_lable37"));
                    }
                }
            } else {
                //console.log("👉 Người dùng nhấn Bắt đầu làm bài thi HSA");
                this.closePopup();
                if (this.confirmPromiseResolve) this.confirmPromiseResolve(true);
            }
        },
        autoStart() {
            //console.log("⏰ Hết 120 giây → tự động bắt đầu");
            this.closePopup();
            if (this.confirmPromiseResolve) this.confirmPromiseResolve(true);
        },
        closePopup() {
            this.showPopup = false;
            clearInterval(this.countdownTimer);
        },
        isDisabled(value) {
            return (
                this.selectedSubjects.length >= 3 &&
                !this.selectedSubjects.includes(value)
            );
        },
        openResultPopup() {
            this.showResultPopup = true;
        },
        closeResultPopup() {
            this.showResultPopup = false;
            window.location.href = "https://sangsang.com.vn/sshome/my-course-b2b?type=pay&cate=exam";
        },
        // end: hsa vnu for sangsang
        // phan loai cau hoi theo nhom tags
        handleTypeTags(testListQuest) {
            let tmp = [];
            let isFind = 0;
            for (let i = 0; i < testListQuest.length; i++) {
                if (tmp.length === 0) {
                    if (testListQuest[i].tags !== null) {
                        for (let j = 0; j < JSON.parse(testListQuest[i].tags).length; j++) {
                            tmp.push({
                                type: testListQuest[i].type,
                                tags_id: JSON.parse(testListQuest[i].tags)[j],
                                question_id: [testListQuest[i].id],
                                total_of_tags_id: 1,
                                total_correct: 0,
                                percent: 0,
                                total_score: 0,
                                max_score_of_tags: 0
                            });
                        }
                    }
                } else {
                    if (testListQuest[i].tags !== null) {
                        for (let j = 0; j < JSON.parse(testListQuest[i].tags).length; j++) {
                            for (let k = 0; k < tmp.length; k++) {
                                if (JSON.parse(testListQuest[i].tags)[j] == tmp[k].tags_id) {
                                    // update trong tmp
                                    tmp[k].question_id.push(testListQuest[i].id);
                                    tmp[k].total_of_tags_id = tmp[k].total_of_tags_id + 1;
                                    isFind = 1;
                                }
                            }
                            if (isFind === 0) {
                                tmp.push({
                                    type: testListQuest[i].type,
                                    tags_id: JSON.parse(testListQuest[i].tags)[j],
                                    question_id: [testListQuest[i].id],
                                    total_of_tags_id: 1,
                                    total_correct: 0,
                                    percent: 0,
                                    total_score: 0,
                                    max_score_of_tags: 0
                                });
                            }
                            isFind = 0;
                        }
                    }
                }
            }
            return this.questionTypeTags = tmp;
        },
        handleTopikLevel(text) {
            if (text === undefined || text === null) {
                return null;
            } else {
                let t = text.split('-');
                return t;
            }
        },
        groupBy(arr, property) {
            return arr.reduce(function (memo, x) {
                if (!memo[x[property]]) {
                    memo[x[property]] = [];
                }
                memo[x[property]].push(x);
                return memo;
            }, {});
        },
        onReady(editor) {
            editor.ui
                .getEditableElement()
                .parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formatTime(d) {
            d = Number(d);
            let h = Math.floor(d / 3600);
            let m = Math.floor((d % 3600) / 60);
            let s = Math.floor((d % 3600) % 60);
            let hDisplay = h >= 10 ? h : "0" + h;
            let mDisplay = m >= 10 ? m : "0" + m;
            let sDisplay = s >= 10 ? s : "0" + s;
            return hDisplay + ':' + mDisplay + ':' + sDisplay;
        },
        secondsToHms(d) {
            d = Number(d);
            let m = Math.floor(d / 60);
            let s = Math.floor((d % 3600) % 60);
            let mDisplay = m >= 10 ? m : "0" + m;
            let sDisplay = s >= 10 ? s : "0" + s;
            return (this.timeOut = mDisplay + ":" + sDisplay);
        },
        showModalEmbed(index, item) {
            this.showModal[index] = !this.showModal[index];
            this.keyInput++;
        },
        handleShowPDF(link) {
            if (typeof link === "string") {
                if (link.includes("pdf")) {
                    return true;
                }
            }
            return false;
        },
        async handleClose() {
            // nếu đang fullscreen thì đóng luôn
            if (document.fullscreenElement && document.exitFullscreen) {
                await document.exitFullscreen();
            }
            if (this.examStarted) {
                this.examStarted = false;
            }
            if (this.examWarningVisible) {
                this.examWarningVisible = false;
            }

            // đóng form làm bài thi
            if (this.user) {
                window.close();
            } else {
                router.push("/student/exam/my-exam");
            }
        },
        handleShowAnswer() {
            if (this.showingAnswer === true) {
                for (let i = 0; i < this.answerRes.length; i++) {
                    if (this.answerRes[i].type !== "Writing" && this.answerRes[i].type !== "Speaking") {
                        if (this.answerRes[i].ans_id.length !== 0) {
                            for (let j = 0; j < this.answerRes[i].ans_id.length; j++) {
                                document.getElementById(
                                    "ans" + i + "_" + this.answerRes[i].ans_id[j]
                                ).className = "redAns";
                            }
                            for (
                                let k = 0;
                                k < this.answerRes[i].answer_correct.length;
                                k++
                            ) {
                                document.getElementById(
                                    "ans" + i + "_" + this.answerRes[i].answer_correct[k]
                                ).className = "greenAns";
                            }
                        } else {
                            if (this.answerRes[i].answer_value != "") {
                                for (
                                    let k = 0;
                                    k < this.answerRes[i].answer_correct.length;
                                    k++
                                ) {
                                    // document.getElementById(
                                    //     "ans" + i + "_" + this.answerRes[i].answer_correct[k]
                                    // ).className = "redAns";

                                    const el = document.getElementById(
                                        "ans" + i + "_" + this.answerRes[i].answer_correct[k]
                                    )
                                    el.className = "greenAns";

                                    // Ẩn 2 phần tử kế tiếp
                                    const next1 = el.nextElementSibling;
                                    const next2 = next1?.nextElementSibling;

                                    if (next2) {
                                        // Tạo phần tử mới
                                        const newEl = document.createElement("div");
                                        newEl.id = "ans" + i + "_" + (this.answerRes[i].answer_correct[k] + 1);
                                        newEl.className = "redAns";
                                        // newEl.textContent = "✅ Đáp án chính xác";
                                        //  newEl.style.color = "green";
                                        // newEl.style.fontWeight = "bold";
                                        // newEl.style.marginLeft = "8px";

                                        // Thêm phần tử này ngay sau next2
                                        next2.insertAdjacentElement("afterend", newEl);

                                        // tao phan tu moi 2
                                        const newE2 = document.createElement("span");
                                        newE2.textContent = this.answerRes[i].answer_value;
                                        newE2.style.margin = "0 0 0 4px";

                                        // Thêm phần tử này ngay sau newE1
                                        newEl.insertAdjacentElement("afterend", newE2);
                                    }
                                    // if (next1) next1.style.display = "none";
                                    // if (next2) next2.textContent  = this.answerRes[i].answer_value;

                                    // $("#" + "ans" + i + "_" + this.answerRes[i].answer_correct[k]).next().hide().next().hide();

                                    // if (el && el.nextElementSibling) {
                                    //     el.nextElementSibling.style.display = "none";
                                    // }
                                }
                            } else {
                                for (
                                    let k = 0;
                                    k < this.answerRes[i].answer_correct.length;
                                    k++
                                ) {
                                    document.getElementById(
                                        "ans" + i + "_" + this.answerRes[i].answer_correct[k]
                                    ).className = "grayAns";
                                }
                            }
                        }
                    }
                }
            }
        },
        handleShowExplain(index) {
            this.showExplain[index] = !this.showExplain[index];
            this.keyInput++;
        },
        removeInputFile(index) {
            this.fileSubmit[index] = null;
            this.keyInput++;
        },
        async countTime() {
            let count = 0;
            let lastTime = new Date();
            this.interval = setInterval(() => {
                count += Date.now() - lastTime.getTime();
                lastTime = new Date();

                let second = (count / 1000).toFixed();

                this.dataRes.time = Number(this.timeDoExam) - Number(second);

                this.secondsToHms(this.dataRes.time);
                this.exam_actual_time = second;
                if (this.dataRes.time === 0 || this.dataRes.time < 0) {
                    this.exam_actual_time = this.timeDoExam;
                    this.submitExam();
                    clearInterval(this.interval);
                    this.$root.toast(
                        this.$t("commons.button.notification"),
                        "success",
                        this.$t(`msg["E_UC6_4"]`)
                    );
                }
            }, 250);
        },
        async submitExam() {
            this.showSubmitPopup = false;
            Cookies.remove("idResultExam");
            if (
                Cookies.get("typeExam") !== "result" &&
                this.dataRes.time_to_play_of_student >= this.dataRes.time_to_play
            ) {
                this.$root.toast(
                    this.$t("msg.E_UC6_20"),
                    "danger",
                    this.$t("msg.E_UC6_21")
                );
                this.handleClose();
                return;
            }
            const dataList = this.dataSubmit.map(el => {
                if (typeof el.ans_id === "number") {
                    el.ans_id = [el.ans_id];
                }
                return el;
            });

            clearInterval(this.interval);
            let data = new FormData();
            for (let i = 0; i < this.dataSubmit.length; i++) {
                if (this.dataSubmit[i].answer === "" && this.fileSubmit[i] === null) {
                    this.dataSubmit[i].answer = "noAnswer";
                }
            }

            const fileSend = this.fileSubmit.filter(function (el) {
                return el != null;
            });
            data.append("duration", this.dataRes.time > 0 ? this.timeDuration - this.dataRes.time : this.timeDuration);
            data.append("user_id", this.user.id);
            data.append("answer", JSON.stringify(this.dataSubmit));
            data.append("exam_id", this.exam_id);

            fileSend.map(index => data.append("file[]", index, index.name));
            this.form.audio_path.map(index => data.append("audio_path[]", index, index.name));
            this.isLoading = true;
            await this.$store.dispatch("exam/submit", data);
            if (this.$store.state.exam.submitExamRes.status === 200) {
                this.isLoading = false;
                // bài thi hsa của vnu
                if (Cookies.get("hsavnu_id_1") || Cookies.get("hsavnu_id_2") || Cookies.get("hsavnu_id_3")) {
                    if (Cookies.get("hsavnu_id_1") == this.exam_id) {
                        this.handleDoExam(Cookies.get("hsavnu_id_2"), Cookies.get("hsavnu_name_2"));
                    } else {
                        if (Cookies.get("hsavnu_id_2") == this.exam_id) {
                            this.handleDoExam(Cookies.get("hsavnu_id_3"), Cookies.get("hsavnu_name_3"));
                        } else if (Cookies.get("hsavnu_id_3") == this.exam_id) {
                            await this.$store.dispatch("exam/submitHsaExamResults", {
                                exam_id1: Cookies.get("hsavnu_id_1"),
                                exam_id2: Cookies.get("hsavnu_id_2"),
                                exam_id3: Cookies.get("hsavnu_id_3"),
                                exam_type3: Cookies.get("hsavnu_option_science_3"),
                                user_id: this.user.id
                            });
                            if (this.$store.state.exam.hsaExamResults.status === 200) {
                                const result_res = this.hsaExamResults.data;
                                if (result_res && result_res.userFullname) {
                                    this.exam_id1 = Cookies.get("hsavnu_id_1");
                                    this.examResult = result_res;
                                    //console.log("ketqua:", result_res)

                                    this.exam_id1 = Cookies.get("hsavnu_id_1");
                                    this.exam_id2 = Cookies.get("hsavnu_id_2");
                                    this.exam_id3 = Cookies.get("hsavnu_id_3");
                                    this.exam_name1 = Cookies.get("hsavnu_name_1");
                                    this.exam_name2 = Cookies.get("hsavnu_name_2");
                                    this.exam_name3 = Cookies.get("hsavnu_name_3");

                                    if (Cookies.get("hsavnu_option_science_3") === "science") {
                                        this.selectedOption = "science";
                                    }

                                    Cookies.remove("hsavnu_id_1");
                                    Cookies.remove("hsavnu_name_1");
                                    Cookies.remove("hsavnu_total_question_1");

                                    Cookies.remove("hsavnu_id_2");
                                    Cookies.remove("hsavnu_name_2");
                                    Cookies.remove("hsavnu_total_question_2");

                                    Cookies.remove("hsavnu_id_3");
                                    Cookies.remove("hsavnu_name_3");
                                    Cookies.remove("hsavnu_option_science_3");

                                    this.openResultPopup();
                                } else {
                                    alert(this.$t("tryExam.sha_vnu_lable38"));
                                }
                            } else {
                                alert(this.$t("tryExam.sha_vnu_lable37"));
                            }
                        }
                    }
                } else {
                    // bài thi thường
                    this.$root.toast(
                        this.$t(`msg["C_UC6_4"]`),
                        "success",
                        this.$t(`msg["C_UC6_4"]`)
                    );
                    this.showingAnswer = true;
                    this.answerRes = this.$store.state.exam.submitExamRes.data;
                    this.handleShowAnswer();
                    this.handleCheckStatus();
                    if (!(this.user && this.user.business_id)) {
                        this.apiDataChartCourseExam();
                    }
                }
            } else {
                this.isLoading = false;
                this.$root.toast(
                    this.$t(`msg["submit_fail"]`),
                    "danger",
                    this.$t(`msg["submit_fail"]`)
                );
                return;
            }

            // nếu đang fullscreen thì đóng luôn
            if (document.fullscreenElement && document.exitFullscreen) {
                await document.exitFullscreen();
            }
            if (this.examStarted) {
                this.examStarted = false;
            }
            if (this.examWarningVisible) {
                this.examWarningVisible = false;
            }

            // kết thúc loading
            this.isLoading = false;

            // trở về đầu trang kết quả
            // window.scrollTo(0, 0);
            const el = document.getElementById("exam-container-trying");
            if (el) {
                el.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        },
        scrollToElement(index) {
            this.$refs['items'][index].scrollIntoView({behavior: "smooth", block: 'center'});
        },
        async apiDataChartCourseExam() {
            // Lay data chart va sugges course and exam
            let paramsAnnalysis = {
                user_id: this.user.id,
                id_submit: Cookies.get("idResultExam"),
                exam_id: this.exam_id, //Number(window.location.search.substring(1).split("&")[0]),
                listen_tags: this.getIdTags(this.questionTypeTagListening),
                speak_tags: this.getIdTags(this.questionTypeTagSpeaking),
                read_tags: this.getIdTags(this.questionTypeTagReading),
                write_tags: this.getIdTags(this.questionTypeTagWriting)
            };

            await this.$store.dispatch("exam/actionDataAnalysisExam", paramsAnnalysis);
            this.dataAnalysis = this.dataAnalysisExam.data;


            this.dataChart = this.dataAnalysis.chart;
            this.dataUserScoreSeq = this.dataAnalysis.user_score_seq;

            if (this.typeListen) {
                this.dataExam = this.dataAnalysis.exam.listen;
                this.dataCourse = this.dataAnalysis.course.listen;
            }
        },
        handleCheckStatus() {
            if (this.showingAnswer === true) {
                this.totalQuestionSelected = 0;
                for (let i = 0; i < this.answerRes.length; i++) {
                    if (this.answerRes[i].type !== "Writing" && this.answerRes[i].type !== "Speaking") {
                        if (this.answerRes[i].ans_id.length !== 0) {
                            var flag = true; // đặt cờ báo là cau đúng
                            var arrTmp = [];
                            for (let j = 0; j < this.answerRes[i].ans_id.length; j++) {

                                var b = this.answerRes[i].ans_id[j];

                                // kiểm tra phần tử b có tồn tại trong mảng 'answer_correct' không
                                var a = this.answerRes[i].answer_correct.some(function (value) {
                                    return value === b;

                                });
                                arrTmp.push(a);


                            }
                            // kiểm tra xem là câu đúng hay câu sai
                            for (let n = 0; n < arrTmp.length; n++) {
                                if (arrTmp[n] === false) {
                                    // day la cau sai
                                    flag = false;
                                    //break;
                                }
                            }

                            // set class thay doi trang thai dung sai cho html
                            if (!flag) {
                                document.getElementById(
                                    "q" + i
                                ).className = "falseAnswer";

                            } else {
                                document.getElementById(
                                    "q" + i
                                ).className = "trueAnswer";

                                // Lay so cau tra loi dung cua cac loai Listening, Reading
                                if (this.answerRes[i].type === "Listening") {
                                    this.correctListen++;
                                } else if (this.answerRes[i].type === "Reading") {
                                    this.correctRead++;
                                }
                                // cap nhat cau dung trong danh sach cau hoi theo nhom tags
                                let question_id = this.answerRes[i].question_id;
                                for (let n = 0; n < this.questionTypeTags.length; n++) {
                                    let inArray = this.questionTypeTags[n].question_id.some(function (value) {
                                        return value === question_id;
                                    });
                                    if (inArray) {
                                        this.questionTypeTags[n].total_correct = this.questionTypeTags[n].total_correct + 1;
                                        this.questionTypeTags[n].percent = ((this.questionTypeTags[n].total_correct / this.questionTypeTags[n].total_of_tags_id) * 100).toFixed(2);
                                    }
                                }
                            }
                            this.totalQuestionSelected++;
                        } else {
                            if (this.answerRes[i].answer_value != "") {
                                document.getElementById(
                                    "q" + i
                                ).className = "falseAnswer";
                                this.totalQuestionSelected++;
                            } else {
                                document.getElementById(
                                    "q" + i
                                ).className = "noAnswer";
                            }
                        }
                    } else if (this.answerRes[i].type === "Writing" || this.answerRes[i].type === "Speaking") {
                        if (this.answerRes[i].answer !== 'noAnswer') {
                            document.getElementById(
                                "q" + i
                            ).className = "answer";
                            this.totalQuestionSelected++;
                        } else {
                            document.getElementById(
                                "q" + i
                            ).className = "noAnswer";
                        }
                        // lay diem va tong diem cua cau hoi writing , speaking
                        let question_id = this.answerRes[i].question_id;
                        let score = this.answerRes[i].score;
                        let score_of_ques = this.answerRes[i].score_of_ques;

                        for (let n = 0; n < this.questionTypeTags.length; n++) {
                            let inArray = this.questionTypeTags[n].question_id.some(function (value) {
                                return value === question_id;
                            });
                            if (inArray) {
                                this.questionTypeTags[n].total_score = this.questionTypeTags[n].total_score + score;
                                this.questionTypeTags[n].max_score_of_tags = this.questionTypeTags[n].max_score_of_tags + score_of_ques;
                                this.questionTypeTags[n].percent = ((this.questionTypeTags[n].total_score / this.questionTypeTags[n].max_score_of_tags) * 100).toFixed(2);
                            }
                        }
                    }
                }
                // sap xep theo percent || a.total_of_tag_id
                this.questionTypeTags.sort((a, b) => a.percent - b.percent || b.total_of_tags_id - a.total_of_tags_id);
            }
        },
        targetTableQuestion(event) {
            var id = event.target.getAttribute('data-question');
            var hcla = document.getElementById(id);
            /*if (hcla.classList.contains('q_selected')) {
                // neu ton tai class q-selected
            }else{
                // neu chua ton tai class q-selected
                //   hcla.className ='q_selected';
            }
            // var a = document.getElementsByClassName('q_selected').length;
            // this.totalQuestionSelected = a;
            // document.getElementsByClassName('total-ques-selected').innerText = '10';
            // console.log(totalQuestionSelected);
            //document.getElementById(id).className
            //console.log(event.target.getAttribute('data-question'));*/
        },
        optionTypeQuestion(event) {
            var nametype = event.target.getAttribute('data-name');
            if (nametype === 'all') {
                this.isAll = true;
                this.isListen = true;
                this.isSpeak = true;
                this.isRead = true;
                this.isWri = true;
            } else if (nametype === 'Listening') {
                this.isAll = false;
                this.isListen = true;
                this.isSpeak = false;
                this.isRead = false;
                this.isWri = false;
            } else if (nametype === 'Speaking') {
                this.isAll = false;
                this.isListen = false;
                this.isSpeak = true;
                this.isRead = false;
                this.isWri = false;
            } else if (nametype === 'Reading') {
                this.isAll = false;
                this.isListen = false;
                this.isSpeak = false;
                this.isRead = true;
                this.isWri = false;
            } else if (nametype === 'Writing') {
                this.isAll = false;
                this.isListen = false;
                this.isSpeak = false;
                this.isRead = false;
                this.isWri = true;
            }
            window.scrollTo(0, 0);
        },
        removeAudio: function (index) {
            this.form.audio_path[index] = '';
            this.audioUpload[index] = '';
            document.getElementById("upload-audio-input" + index).value = null;
        },
        handleAudioUpload(event, index) {
            if (event.target.files[0].size / 1048576 > 10) {
                this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
                    title: this.$t("difficulty.notice"),
                    autoHideDelay: 5000,
                    variant: "danger"
                });
                return;
            }
            this.audioUpload[index] = event.target.files[0];
            this.form.audio_path[index] = this.audioUpload[index];
            this.audioUpload[index] = URL.createObjectURL(this.audioUpload[index]);
        },
        handleShowTableQuestions() {
            this.showTableQuestions = !this.showTableQuestions;
        },
        handleTabAnalysisDetail() {
            this.isAnalysisDetail = true;
            this.isAnswerDetail = false;
        },
        handleTabAnswerDetail() {
            this.isAnalysisDetail = false;
            this.isAnswerDetail = true;
        },
        handleLinkHistorySubmits() {
            let id = Number(window.location.search.substring(1).split("&")[0]);
            let name = String(window.location.search.substring(1).split("&")[1]);
            Cookies.set("idExam", id);
            window.open(`/student/exam/my-exam/result?${name}`, '_blank'); // mo sang tab khac
        },
        typeClick(event) {
            var nametype = event.target.getAttribute('data-name');
            if (nametype == 'Listening') {
                this.typeListen = true;
                this.typeRead = false;
                this.typeSpeak = false;
                this.typeWrite = false;
                this.dataExam = this.dataAnalysis.exam ? this.dataAnalysis.exam.listen : [];
                this.dataCourse = this.dataAnalysis.course ? this.dataAnalysis.course.listen : [];

            } else if (nametype == 'Reading') {
                this.typeListen = false;
                this.typeRead = true;
                this.typeSpeak = false;
                this.typeWrite = false;

                this.dataExam = this.dataAnalysis.exam ? this.dataAnalysis.exam.read : [];
                this.dataCourse = this.dataAnalysis.course ? this.dataAnalysis.course.read : [];

            } else if (nametype == 'Speaking') {
                this.typeListen = false;
                this.typeRead = false;
                this.typeSpeak = true;
                this.typeWrite = false;

                this.dataExam = this.dataAnalysis.exam ? this.dataAnalysis.exam.speak : [];
                this.dataCourse = this.dataAnalysis.course ? this.dataAnalysis.course.speak : [];

            } else if (nametype == 'Writing') {
                this.typeListen = false;
                this.typeRead = false;
                this.typeSpeak = false;
                this.typeWrite = true;

                this.dataExam = this.dataAnalysis.exam ? this.dataAnalysis.exam.write : [];
                this.dataCourse = this.dataAnalysis.course ? this.dataAnalysis.course.write : [];


            }
        },
        showTypeForMobile(event) {
            var nametype = event.target.getAttribute('data-name');
            if (nametype == 'Listening') {
                this.showTypeListenForMobile = true;
                this.showTypeReadForMobile = false;
                this.showTypeSpeakForMobile = false;
                this.showTypeWriteForMobile = false;
            } else if (nametype == 'Reading') {
                this.showTypeListenForMobile = false;
                this.showTypeReadForMobile = true;
                this.showTypeSpeakForMobile = false;
                this.showTypeWriteForMobile = false;
            } else if (nametype == 'Speaking') {
                this.showTypeListenForMobile = false;
                this.showTypeReadForMobile = false;
                this.showTypeSpeakForMobile = true;
                this.showTypeWriteForMobile = false;
            } else if (nametype == 'Writing') {
                this.showTypeListenForMobile = false;
                this.showTypeReadForMobile = false;
                this.showTypeSpeakForMobile = false;
                this.showTypeWriteForMobile = true;
            }
        },
        getIdTags(input) {
            if (input.length > 0) {
                let tmp = [];
                for (let i = 0; i < input.length; i++) {
                    if (i < 3) {
                        tmp.push(input[i].tags_id);
                    }
                }
                return tmp.join('-').toString();
            } else {
                return '';
            }

        },
        getText() {
            if (this.typeListen) {
                return this.$t("tryExam.listen");
            } else if (this.typeRead) {
                return this.$t("tryExam.read");
            } else if (this.typeSpeak) {
                return this.$t("tryExam.speak");
            } else if (this.typeWrite) {
                return this.$t("tryExam.write");
            }
        },
        getNameTags(input) {
            //locale === 'vi' ? listTags[qTag.tags_id][0].name : listTags[qTag.tags_id][0].name_ko ? listTags[qTag.tags_id][0].name_ko : listTags[qTag.tags_id][0].name
            if (this.locale === 'vi') {
                return this.listTags[input][0].name;
            } else if (this.locale === 'kr' && this.listTags[input][0].name_ko) {
                return this.listTags[input][0].name_ko;
            } else {
                return this.listTags[input][0].name;
            }
        },
        recordAudio(audio, index) {
            let file = new File([audio], this.exam_id + '_' + index + '_record.mp3', {type: 'audio/mp3'});
            this.form.audio_path[index] = file;

            // this.audioUpload[index] = URL.createObjectURL(this.form.audio_path[index]);
            const wavFile = new File([audio], 'record.wav', {type: 'audio/wav'});
            this.audioUpload[index] = URL.createObjectURL(wavFile);
        },
        isStartRecord(value, index) {
            this.startRecord[index] = value;
        },
        stopOthers(nameRef, index) {
            if (this.currentAudioPlaying !== null && this.currentAudioPlaying !== nameRef + '-' + index) {
                if (this.$refs[this.currentAudioPlaying][0]) {
                    let player = this.$refs[this.currentAudioPlaying][0];
                    player.pause();
                }
            }
            this.currentAudioPlaying = nameRef + '-' + index;
        },
        // Chỉ cho phép nhập số và tối đa 1 dấu '.', ',', '/'
        filterNumber(index, i, ans_value, event) {
            let value = event.target.value;

            // Loại bỏ ký tự không hợp lệ
            value = value.replace(/[^0-9.,/-]/g, '');

            // Giới hạn tối đa 1 dấu chấm, 1 dấu phẩy, 1 dấu /
            const limitSymbol = (str, symbol) => {
                const parts = str.split(symbol);
                return parts.length > 2 ? parts[0] + symbol + parts[1] : str;
            };

            value = limitSymbol(value, '.');
            value = limitSymbol(value, ',');
            value = limitSymbol(value, '/');
            value = limitSymbol(value, '-');

            // Cập nhật lại giá trị vào mảng userInput
            this.$set(this.userInput, index, value);

            // Gọi kiểm tra đáp án
            this.checkAnswer(index, i, ans_value, value);
        },

        stripTags(html) {
            return html.replace(/<[^>]*>/g, '').trim();
        },
        checkAnswer(index, i, ans_value, value) {
            const userVal = parseFloat(this.userInput[index]);
            if (parseFloat(userVal) === parseFloat(this.stripTags(ans_value))) {
                // console.log('ok');
                this.dataSubmit[index].ans_id = i;
            } else if (userVal === '' || isNaN(parseFloat(userVal))) {
                this.dataSubmit[index].ans_id = [];
                this.dataSubmit[index].answer_value = '';
            } else {
                // console.log('ok -2');
                this.dataSubmit[index].ans_id = [];
                this.dataSubmit[index].answer_value = value;
            }
            // this.$set(this.result, index, userVal === correct);
        },
        handleDoExam(id, name) {
            this.$router.push(`/student/exam/try-exam?${id}&${name.replace(/ /g, "-")}`).then(() => {
                window.location.reload();
            });
        },
        /*handleViewResult1() {
            //Cookies.set("idExam", this.exam_id1);
            // this.$router.push(`/student/exam/my-exam/result?${this.exam_name1.replace(/ /g, "-")}`);
            const id = this.exam_id1
            const name = this.exam_name1
            Cookies.set("idExam", id)
            const url = `/student/exam/my-exam/result?examName=${encodeURIComponent(name.replace(/ /g, "-"))}`
            window.open(url, "_blank") // ✅ mở tab mới
        },
        handleViewResult2() {
            const id = this.exam_id2
            const name = this.exam_name2
            Cookies.set("idExam", id)
            const url = `/student/exam/my-exam/result?examName=${encodeURIComponent(name.replace(/ /g, "-"))}`
            window.open(url, "_blank") // ✅ mở tab mới
        },
        handleViewResult3() {
            const id = this.exam_id3
            const name = this.exam_name3
            Cookies.set("idExam", id)
            const url = `/student/exam/my-exam/result?examName=${encodeURIComponent(name.replace(/ /g, "-"))}`
            window.open(url, "_blank") // ✅ mở tab mới
        },*/
        hsa_vnu_seq(id) {
            let seq = 0;
            if (Cookies.get("hsavnu_id_1") || Cookies.get("hsavnu_id_2") || Cookies.get("hsavnu_id_3")) {
                if (Cookies.get("hsavnu_id_1") && Cookies.get("hsavnu_id_1") == id) {
                    seq = 1;
                }
                if (Cookies.get("hsavnu_id_2") && Cookies.get("hsavnu_id_2") == id) {
                    seq = 2;
                }
                if (Cookies.get("hsavnu_id_3") && Cookies.get("hsavnu_id_3") == id) {
                    seq = 3;
                }
            }
            return seq;
        },
        normalizeLabel(label) {
            let clean = label.trim();

            // ====== IGNORE LIST ======
            const ignorePatterns = [
                /tâm lý|tâm ly|phân ly|phân lý|hóa lý|hoa ly/i,
                /địa phương/i,
                /sinh hoạt/i
            ];

            for (const regex of ignorePatterns) {
                if (regex.test(clean)) return clean;
            }

            // ====== MÔN VẬT LÝ ======
            if (/(^|[^a-zA-Zà-ỹ])(lý)(?=([^a-zA-Zà-ỹ]|$))/i.test(clean)) {
                return "Vật lý";
            }

            // ====== MÔN HÓA HỌC ======
            if (/(^|[^a-zA-Zà-ỹ])(hóa|hoá|hoa)(?=([^a-zA-Zà-ỹ]|$))/i.test(clean)) {
                return "Hóa học";
            }

            // ====== MÔN SINH HỌC ======
            if (/(^|[^a-zA-Zà-ỹ])(sinh)(?=([^a-zA-Zà-ỹ]|$))/i.test(clean)) {
                return "Sinh học";
            }

            // ====== MÔN LỊCH SỬ ======
            if (/(^|[^a-zA-Zà-ỹ])(sử)(?=([^a-zA-Zà-ỹ]|$))/i.test(clean)) {
                return "Lịch sử";
            }

            // ====== MÔN ĐỊA LÝ ======
            if (/(^|[^a-zA-Zà-ỹ])(địa|dia)(?=([^a-zA-Zà-ỹ]|$))/i.test(clean)) {
                return "Địa lý";
            }

            // ====== MẶC ĐỊNH ======
            let lower = clean.toLowerCase();
            return lower.charAt(0).toUpperCase() + lower.slice(1);
        }
        ,
        clearFormatContent(content) {
            let html = String(content || '');

            // 1️⃣ Xóa comment ẩn (Word hay chèn)
            html = html.replace(/<!--[\s\S]*?-->/g, '');

            // 2️⃣ Xóa các thuộc tính inline gây lỗi giao diện
            html = html.replace(/\s?(style|class|id|lang|width|height|align|border)="[^"]*"/gi, '');

            // 3️⃣ Xóa các tag đặc biệt của Word (v:, o:, w:)
            html = html.replace(/<(\/)?(v|o|w):[^>]*>/gi, '');

            // 4️⃣ Xóa các tag không mong muốn như <span>, <font>, <xml>, <meta>, <link>, <style>, <script>
            html = html.replace(/<\/?(span|font|xml|meta|link|style|script)[^>]*>/gi, '');

            // 5️⃣ Chuẩn hóa lại <p> và <div>
            html = html.replace(/<p[^>]*>/gi, '<p>');
            html = html.replace(/<div[^>]*>/gi, '<div>');

            // 6️⃣ Xóa tất cả ký tự &nbsp; (non-breaking space)
            html = html.replace(/&nbsp;/gi, ' ');

            // 7️⃣ Xóa khoảng trắng thừa đầu/cuối
            html = html.trim();

            return html;
        }
    }
};
</script>
<style>
/* =========================
   begin: hsa vnu for sangsang
   ========================= */
/* Nền mờ */
.wait-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5); /* mờ */
    backdrop-filter: blur(2px); /* làm mờ nền */
    z-index: 9999;

    display: flex;
    justify-content: center;
    align-items: center;
}

/* Khung popup */
.wait-popup {
    background: white;
    padding: 25px 35px;
    border-radius: 12px;
    width: 650px;
    text-align: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

/* Tiêu đề */
.wait-title {
    font-size: 20px;
    /*font-weight: bold;*/
    margin-bottom: 15px;
}

/* Thanh progress */
.wait-progress {
    width: 100%;
    height: 12px;
    background: #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
}

.wait-progress-fill {
    height: 100%;
    background: #3fa9f5; /* màu xanh chạy */
    transition: width 0.3s linear;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3); /* tối nhẹ */
    backdrop-filter: blur(6px); /* 🔥 làm mờ nền phía sau */
    -webkit-backdrop-filter: blur(6px); /* hỗ trợ Safari */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.popup {
    background: #fff;
    padding: 20px 25px;
    border-radius: 10px;
    width: 50%;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
    .popup {
        width: 90% !important;
    }
}

.popup_submit {
    background: #fff;
    padding: 20px 25px;
    border-radius: 10px;
    width: 320px;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.btn_popup {
    margin-top: 12px;
    padding: 8px 16px;
    background: #6674bb;
    border: none;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
}

.btn_popup:hover {
    background: #556095FF;
}

.btn-group {
    margin-top: 15px;
    display: flex;
    justify-content: space-around;
}

.btn-continue {
    background: #fdd835;
    color: #000;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    font-weight: bold;
}

.btn-submit {
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    font-weight: bold;
}

.subject-select-wrapper {
    text-align: center;
    font-family: "Roboto", sans-serif;
}

.subject-title {
    font-size: 20px;
    font-weight: bold;
    color: #2e7d32;
    margin-bottom: 6px;
}

.subject-desc {
    font-size: 15px;
    color: #555;
    margin-bottom: 18px;
}

.subject-radio-group {
    display: flex;
    justify-content: center;
    gap: 25px;
    margin-bottom: 20px;
}

.subject-radio input {
    margin-right: 6px;
    cursor: pointer;
}

.subject-checkbox-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: fit-content;
    margin: 0 auto 20px;
    padding: 10px 20px;
    background: #f9f9f9;
    border-radius: 8px;
    border: 1px solid #ddd;
}

.subject-checkbox label {
    font-size: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.subject-checkbox input {
    margin-right: 8px;
}

.subject-note {
    font-weight: bold;
    color: #333;
    padding-bottom: 15px;
}

.subject-warning {
    font-size: 13px;
    color: #d32f2f;
    margin-top: 10px;
}

.btn-start-exam {
    margin-top: 10px;
    width: 150px;
    transition: background 0.3s;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}

.btn-start-exam {
    margin-top: 10px;
    width: 150px;
    transition: background 0.3s, opacity 0.3s;
}

.btn-start-exam:disabled {
    opacity: 0.5; /* mờ đi */
    cursor: not-allowed; /* đổi con trỏ chuột */
}

.exam-parts-table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px auto 20px;
    font-size: 15px;
}

.exam-parts-table th {
    background: #f5f5f5;
    font-weight: bold;
    padding: 8px 10px;
    text-align: center;
    border-bottom: 2px solid #ddd;
}

.exam-parts-table td {
    padding: 8px 10px;
    text-align: left;
    border-bottom: 1px solid #eee;
}

.exam-parts-table td:first-child,
.exam-parts-table th:first-child {
    width: 90px;
    text-align: center;
}

@media (max-width: 768px) {
    .exam-parts-table {
        font-size: 14px;
    }

    .exam-parts-table td:first-child {
        width: 70px;
    }
}

.result-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000; /* cao hơn popup cũ */
}

.popup-result-box {
    background: #ffffff;
    padding: 25px 30px;
    border-radius: 10px;
    width: 650px;
    max-width: 95%;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
    text-align: center;
    animation: fadeInResult 0.3s ease-in-out;
    font-family: "Roboto", sans-serif;
}

.result-title {
    color: #2e7d32;
    font-weight: 700;
    font-size: 22px;
    margin-bottom: 15px;
}

.result-line {
    font-size: 16px;
    margin-bottom: 6px;
    text-align: left;
}

.result-table {
    width: 100%;
    border-collapse: collapse;
    margin: 15px 0;
    font-size: 15px;
}

.result-table th {
    background-color: #f5f5f5;
    padding: 10px;
    border-bottom: 2px solid #ccc;
    color: #333;
}

.result-table td {
    border-bottom: 1px solid #eee;
    padding: 8px;
}

.result-table a {
    color: #1976d2;
    text-decoration: none;
    font-weight: 500;
}

.result-table a:hover {
    text-decoration: underline;
}

// popup kết quả bài thi hsa
.btn-close-result {
    margin-top: 12px;
    padding: 8px 16px;
    background: #6674bb;
    border: none;
    color: #fff;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s;
}

.btn-close-result:hover {
    background: #5560a8;
}

@keyframes fadeInResult {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* =========================
   end: hsa vnu for sangsang
   ========================= */
.tryExam-content {
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 10px 25px;
    border-radius: 15px;
    background-color: #f5f5f5;
}

.page-name {
    padding: 0px !important;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 24px;
    color: #6674bb;
    width: 400px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
}

.tryExam-content__mobile--Date {
    width: 63%;
    justify-content: space-between;
}

.tryExam-content__mobile {
    position: sticky;
    top: 64px;
    z-index: 2;
    background-color: white;
    width: 100%;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.10);
    border-radius: 5px;
    border: 1px solid #F0F0F0;
}

.count_mess_and_up_file {
    position: absolute;
    right: 3px;
    bottom: 5px;
}

.count_message {
    /* position: absolute;
   right: 3px;
   bottom: 5px; */
    font-size: 12px;
    padding: 5px;
    border-radius: 5px;
}


.total-question {
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
}


.yellowButton {
    background: #FF9C6E;
    border-radius: 10px;
    border: none;
    font-weight: 500;
    color: white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);

}

.video-wrapper {
    z-index: 9999;
}

.card-chart {
    position: relative;
    height: 9px;
    padding: 0px !important;
    margin-right: 10px;
}

.card-bar {
    display: block !important;
    position: absolute;
    width: 100%;
    padding: 4px 0px;
    background-color: #e5e5e5;
    border-radius: 10px !important;
    overflow: hidden;
}

.bg-1 {
    background-color: #7ACC00 !important;
}

.bg-required {
    background-color: #CF4141 !important;
}

.bg-3 {
    background: #409878 !important;
}

.bg-2 {
    background: #6674BB !important;
}


.total-question__mobile {
    display: none;
}


.position-text p {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #0770ab;
    padding: 0;
}

.question-title,
textarea {
    border: 1px solid #c4c4c4;
    border-radius: 5px;
    min-height: 100px;
    background-color: white;
}

.tableQuestion td {
    padding: 30px;
}

.groupButtonScore {
    width: 50%;
}


.answerIndex {
    border-radius: 50%;
    border: 1px solid #8C8C8C;
    background-color: white !important;
    color: black !important;
    font-size: 13px;
    /* padding: 0px 6px; */
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-control-file {
    display: none;
}

.form-control-file__label {
    cursor: pointer;
}

.doing-question:hover {
    background-color: #ffbf00 !important;
    color: white !important;
}

#pop-up {
    position: fixed;
    display: flex;
    top: 0px;
    left: -1px;
    z-index: 9999;
    background-color: black;
    height: 100vh;
    width: 100%;
    opacity: 0.4;
    align-items: center;
    justify-content: center;
}

.answerShow {
    max-height: 300px;
    /* margin-right: 12px; */
}

.answerShow img {
    width: auto; /*70%;*/
    object-fit: contain;
    height: 100%;
    max-width: calc(100% - 50px);
}

.nameInputFile {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px !important;
    max-width: 200px;
}

.questionImage {
    width: 75%; /*100%;*/
    margin-bottom: 20px;
}

.row {
    margin: 0px !important;
}

#pop-up {
    position: fixed;
    display: flex;
    top: 0px;
    left: -1px;
    z-index: 9999;
    background-color: black;
    height: 100vh;
    width: 100%;
    opacity: 0.4;
    align-items: center;
    justify-content: center;
}

.redAns {
    border-radius: 50%;
    border: solid 1px #E45353;
    background-color: #E45353 !important;
    color: black !important;
    font-size: 12px;
    /* padding: 0px 6px; */
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('../../assets/images/Exam/sai.png');
    background-position: center center;
    background-repeat: no-repeat;

}

.greenAns {
    border-radius: 50%;
    border: solid 1px #7ACC00;
    background-color: #7ACC00 !important;
    color: black !important;
    font-size: 12px;
    /* padding: 0px 6px; */
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('../../assets/images/Exam/dung.png');
    background-position: center center;
    background-repeat: no-repeat;
}

.grayAns {
    border-radius: 50%;
    border: solid 1px #9b9b9b;
    background-color: #c3c3c3f4 !important;
    color: black !important;
    font-size: 13px;
    /* padding: 0px 6px; */
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.imageExplain {
    margin-top: 20px;
    max-width: 100%;
    object-fit: contain;
    height: auto;
    max-height: 300px;
}

.yellowButton__hover:hover {
    background: #ffcb40 !important;
    color: white !important;
}


.table tbody + tbody {
    border-top: none;
}

.table-bordered {
    border: none;
}

textarea:disabled {
    -webkit-text-fill-color: black !important;
    opacity: 1; /* required on iOS */
    color: black !important;
}

.containerEmbed,
.containerEmbedAudio {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.containerEmbedAudio {
    padding-top: 43%;
}

.containerEmbed iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}

.containerEmbedAudio iframe {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}

.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable) {
    height: 150px;
    border: 1px solid #c4c4c4;
    overflow: auto;
    resize: both;
}

tr.row .ck.ck-toolbar.ck-rounded-corners {
    display: none;
}


.color-black {
    color: black;
}

.color-1 {
    color: #00253F;
}

.color-2 {
    color: #616161;
}

.color-3 {
    color: #1C0A52
}

.color-4 {
    color: #282D63;
}

.color-5 {
    color: #E25458;
}

.color-6 {
    color: #4ECB69;
}

.color-7 {
    color: #A52427;
}

.fsize-12 {
    font-size: 12px;
}

.fsize-13 {
    font-size: 13px;
}

.fsize-14 {
    font-size: 14px;
}

.fsize-15 {
    font-size: 15px;
}

.fsize-16 {
    font-size: 16px;
}

.fsize-17 {
    font-size: 17px;
}

.fsize-18 {
    font-size: 18px;
}

.fsize-20 {
    font-size: 20px;
}

.fsize-22 {
    font-size: 22px;
}

.fsize-24 {
    font-size: 24px;
}

.fsize-30 {
    font-size: 30px;
}

.fsize-32 {
    font-size: 32px;
}


.fw-500 {
    font-weight: 500;
}

.fw-600 {
    font-weight: 600;
}

.time-count__input {
    font-weight: 700;
    font-size: 18px;
    color: #7ACC00;
    text-align: center;
}

.time-count__icon .input-group-text {
    background: none !important;
    border: none !important;
    padding: 0 !important;
}

.area-count-time {
    display: flex;
    flex-direction: column-reverse;
}

.item-q {
    background: #FFFFFF;
    border-radius: 20px;
    margin-bottom: 10px;
    padding: 15px;
    display: none;
    box-shadow: 0px 5px 8px #ccc;
}

.item-q.act {
    display: block;
}

.t-question {
    height: auto;
    /* max-height: 108px;*/
    overflow: auto;
    margin: 10px 0;
}

.fix-text-number-line {
    display: -webkit-box;
    -webkit-line-clamp: var(--number);
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.c-show-less-text {
    text-align: right;
    color: #6674BB;
    cursor: pointer;
    text-decoration: underline;
    font-size: 15px;
}

.number-question {
    font-weight: 600;
}

.op-type {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
}

.op-type span {
    background: #6674BB;
    border-radius: 10px;
    color: white;
    font-size: 18px;
    padding: 5px 10px;
    cursor: pointer;
}

.op-type span.act {
    background: #E5EAFF;
    color: #485CC7;
}

.list-nb-question {
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    padding: 20px 5px 20px 15px;
    /*margin: 15px 0;*/
}

.nb-q {
    height: 300px;
    overflow: auto;
}

.nb-q span {
    background: #F2F3F7;
    border-radius: 10px;
    /* padding: 8px; */
    font-weight: 600;
    font-size: 18px;
    color: #262626;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 35px;
    min-height: 35px;
    margin: 4px;
    cursor: pointer;
    padding: 5px;
}

.nb-q span.trueAnswer {
    color: white;
    background: #7ACC00;
}

.nb-q span.falseAnswer {
    color: white;
    background: #E45353;
}

.nb-q span.noAnswer {
    color: white;
    background: #CCC;
}

.total-my-score {
    font-weight: 700;
    font-size: 70px;
    color: white;
    background: #6F84CA;
    box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 20px;
}

.overview-result {
    background: white;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    padding: 25px 0px;
    margin-bottom: 0px;
    height: 100%;
}

.nb-q .q_selected {
    background: #FFFFFF;
    border: 2px solid #485CC7;
    color: #485CC7;
}

.status-true {
    color: #7ACC00;
}

.status-false {
    color: #E45353;
}

input[type='radio'], input[type='checkbox'] {
    width: 22px;
    height: 22px;
    cursor: pointer;
}

input[type="radio"]:checked,
input[type="checkbox"]:checked {
    accent-color: #6674BB;
}

.no-q-noti {
    font-size: 18px;
    padding: 80px 20px;
    text-align: center;
    background: #ccc;
    margin: 20px 0 20px 0;
}

/*update by: tiemtt*/
.upload-audio {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.upload-audio-button label {
    margin-bottom: 0px;
    padding: 10px;
}

.upload-audio .upload-audio-button {
    display: flex;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    border-radius: 2px;
    border: none;
    font-size: 15px;
    align-items: center;
    position: relative;
    justify-content: center;
}

.upload-audio #upload-audio-input__BV_file_outer_ {
    display: none;
}

.upload-audio .pr-1-audio,
.upload-audio .custom-file-label {
    display: none;
}

#audio-preview {
    padding: 10px;
    width: 100%;
    align-items: center;
}

.embed-audio {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.embed-audio button {
    width: 27%;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    border-radius: 2px;
    border: none;
    color: black;
}

.embed-audio input {
    width: 72%;
    background: #e5eaff;
    border-radius: 3px;
    border: none;
    padding: 5px 10px;
}

.area-table-ques {
    position: sticky;
    top: 150px;
}

.table-ques.show_mobile {
    position: fixed;
    left: 15px;
    right: 15px;
    top: 72px;
    z-index: 9999;
    padding-top: 10px;
    background: white;
}

.table-ques.show_mobile .list-nb-question {
    margin-bottom: 0;
}

/* .table-ques.show_mobile .nb-q{
    height: 180px;
} */
.fix-sticky {
    position: sticky;
    top: 205px;
}

.area-time-complete {
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    padding: 15px;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.area-time-complete .t-1 {
    font-weight: 600;
    font-size: 20px;
}

.area-time-complete .t-2 {
    font-weight: 300;
    font-size: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
}

.area-time-complete .t-3 {
    font-weight: 500;
    font-size: 20px;
}

.area-time-complete .t-2 span {
    margin-top: -8px;
    margin-left: 5px;
}

.area-time-complete > p {
    width: 100%;
}

.area-buttons-tabs {
    display: flex;
    align-items: center;

}

.area-buttons-tabs span {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    border: 1px solid #75787B;
    padding: 10px 10px;
    color: #75787B;
    font-size: 16px;
    cursor: pointer;
    width: 220px;
}

.area-buttons-tabs .act {
    color: white;
    background: #6674BB;
}

.analysis-detaile {
    width: 1132px;
    height: 1106px;
    background: url('../../assets/images/Exam/try_exam_bg_tags_1.png') 0 0 no-repeat;
    background-size: 100%;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    margin-top: -100px;
    margin-left: -80px;
}

.group {
    /* display: none; */
    width: 36%;
    /* background: white; */
    /* height: 320px; */
    overflow-y: auto;
    padding: 10px;
    border-radius: 10px;
    position: relative;
    /* z-index: 2; */
    padding-right: 22px;
    margin: 0 !important;
    position: absolute;
    aspect-ratio: 1/0.78;
}

.group-1 {
    /* margin: 125px 0px 0 133px; */
    top: 11.5%;
    left: 11.6%;
}

.group-2 {
    /* margin: 125px 0 0 55px; */
    top: 11.5%;
    left: 52.6%;
}

.group-3 {
    /* margin: 70px 0px 0 133px; */
    top: 58%;
    left: 11.6%;
}

.group-4 {
    /* margin: 70px 0 0 55px; */
    top: 58%;
    left: 52.6%;
}

.area-overview .tt {
    background: url('../../assets/images/Exam/try-exam-1.png') 0 0 no-repeat;
    padding: 10px 0 30px 65px;
    position: relative;
    margin: 0 0 20px 0 !important;
}

.area-overview .tt-sub {

    margin: 0 0 20px 52px !important;
}

.area-overview .tt::after {
    content: '';
    position: absolute;
    border: 1px solid #040315;
    width: 187px;
    left: 54px;
    bottom: 31px;

}

.tab-button {
    /* position: absolute;
    left: 0;
    top: 348px;
    right: 0;
    display: none;
    flex-wrap: wrap; */
}

/* .tab-button div {
    width: 50%;
    margin-bottom: 36px;
}
.tab-button div:nth-of-type(2n+1) span{
    margin-left: 70px;
}
.tab-button div:nth-of-type(2n) span{
    margin-left: 305px;
} */
.tab-button div span {
    font-size: 30px;
    color: #14175A;
    font-weight: 500;
    position: absolute;
}

.tab-button .b-listen span {
    top: 43.9%;
    left: 16.5%;
}

.tab-button .b-read span {
    top: 43.9%;
    left: 79.5%;
}

.tab-button .b-speak span {
    top: 51.9%;
    left: 16.5%;
}

.tab-button .b-write span {
    top: 51.9%;
    left: 79.5%;
}

.note {
    margin: -100px 0 0 53px;
}

.area-analysis-score > div {
    margin-left: 30px;
}

.area-analysis-score .tt {
    background: url('../../assets/images/Exam/try-exam-4.png') 0 0 no-repeat;
    padding: 10px 0 30px 65px;
    position: relative;
    margin: 0 0 20px 0 !important;
}

.area-analysis-score .tt::after {
    content: '';
    position: absolute;
    border: 1px solid #040315;
    width: 262px;
    left: 48px;
    bottom: 31px;

}

.t-list {
    display: list-item;
    margin-left: 35px;
}

.kq {
    background: url('../../assets/images/Exam/try-exam-5.png') 0 0 no-repeat;
    width: 160px;
    height: 160px;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.kq p {
    text-align: center;
    line-height: 1;
    margin-top: -15px;
}

.kq p span {
    line-height: 1;
}

.compare-score div {
    background: url('../../assets/images/Exam/try-exam-6.png') 0 0 no-repeat;
    height: 100px;
    position: relative;
    width: 80%;
    margin: 25px auto;
    max-width: 100%;
}

.compare-score div p {
    position: absolute;
    left: 182px;
    bottom: 20px;
}

.compare-all-student .text {
    border-radius: 15px;
    background: #95A9F0;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    padding: 10px;
    color: white;
    font-size: 18px;
    display: flex;
    align-items: center;
}

.compare-all-student .text .t-1 {
    width: calc(100% - 50px);
    padding: 10px;
}

.compare-all-student .text .t-2 {
    background: url('../../assets/images/Exam/try-exam-7.png') 0 0 no-repeat;
    width: 45px;
    height: 45px;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #363572;
    font-size: 20px;
    font-weight: 600;

}

.solution-consulting .tt {
    background: url('../../assets/images/Exam/try-exam-9.png') 0 0 no-repeat;
    padding: 10px 0 30px 65px;
    position: relative;
    margin: 0 0 10px 0 !important;
}

.solution-consulting .tt::after {
    content: '';
    position: absolute;
    border: 1px solid #040315;
    width: 295px;
    left: 40px;
    bottom: 30px;
}

.control-t span {
    font-size: 18px;
    color: #6674BB;
    padding: 7px 0px;
    display: inline-block;
    border-radius: 10px;
    background: #FFF;
    box-shadow: -1px 2px 4px 0px rgba(0, 0, 0, 0.25);
    margin: 0 8px 8px 0;
    cursor: pointer;
    width: 70px;
    text-align: center;
}

.control-t span:last-of-type {
    margin: 0;
}

.control-t span.act {
    color: white;
    background: #6674BB;
}

.solution-consulting .t-3 {
    background: url('../../assets/images/Exam/try-exam-10.png') 0 0 no-repeat;
    padding-left: 50px;
    min-height: 43px;
    /* display: flex; */
    align-items: center;
    margin-left: 50px;
}

.group-slides .t-4, .group-slides .t-5 {
    background: url('../../assets/images/Exam/try-exam-11.png') -7px 0 no-repeat;
    padding-left: 50px;
    min-height: 48px;
    /* display: flex; */
    align-items: center;
    font-size: 16px;
    color: #080255;
    padding-right: 35px;
    margin-left: 30px;
}

.group-slides .t-5 {
    background: url('../../assets/images/Exam/try-exam-27.png') 0px 0 no-repeat;
}

.skills-need-advance {
    background: url('../../assets/images/Exam/try-exam-12.png') 0px 0 no-repeat;
    background-size: cover;
    width: 100%;
    max-width: 671px;
    height: 375px;
    padding: 112px 0 0 160px;
    margin: 0 auto;
    position: relative;
}

.skills-need-advance .text-noti {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.skills-need-advance .gr {
    display: none;
    width: 360px;
    max-width: 100%;
}

.skills-need-advance .gr.act {
    display: block;
}

.analysis-advance .area-recommend {
    position: sticky;
    top: 150px;
    height: auto;
    overflow: auto;
    background: #E5EAFF;
    border-radius: 10px;
}

.analysis-advance .area-recommend .ar-gr {
    overflow: auto;
    height: 700px;
}

.analysis-advance .area-recommend .area-slides {
    background: none;
    padding-top: 10px;
}

.chart-score {
    width: calc(100% - 40px);
    position: relative;
}

.chart-score .y {
    position: absolute;
    left: 12px;
    top: -5px;
    font-size: 15px;
}

.chart-score .x {
    position: absolute;
    left: calc(100% + 5px);
    bottom: 0;
    font-size: 15px;
}

.des-chart {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.des-chart span {
    padding: 0 0 0 15px;
    position: relative;
    display: inline-block;
}

.des-chart span::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: red;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}

.des-chart span:nth-of-type(1):after {
    background: rgb(0, 0, 0, 1);
}

.des-chart span:nth-of-type(2):after {
    background: rgba(255, 92, 92, 1);
}

.des-chart span:nth-of-type(3):after {
    background: rgba(56, 183, 255, 1);
}

.no-data-question-type {
    background: url('../../assets/images/Exam/try-exam-3.png') 0 center no-repeat;
    background-size: 100%;
    height: 100%;
    width: 100%;
    position: relative;
}

.no-data-question-type p {
    font-size: 12px;
    font-style: italic;
    color: #280B35;
    position: absolute;
    top: 27%;
    right: 6%;
    left: 39%;
}

/* .chart-score div{
   height: 400px;
} */

@media (max-width: 1580px) {
    .analysis-detaile {
        width: 100%;
        margin: -8% 0 0 0;
        background-position: 0 0;
        background-size: 100%;
        height: auto;
        /* min-height: 100%; */
        aspect-ratio: 1132/1106;
    }

    .group .item > p:first-child {
        font-size: 14px;
    }

    /* .group{
        width: 39%;
        height: 32%;
    }
    .group-1{
        margin: 7% 0 0 8%;
    }
    .group-2{
        margin: 7% 0 0 6%;
    }
    .group-3{
        margin: 6% 0 0 8%;
    }
    .group-4{
        margin: 6% 0 0 6%;
    } */
    .note {
        margin: -60px 0 0 53px;
    }

    .tab-button div span {
        font-size: 21px;
        margin-top: 2px;
    }

    .no-data-question-type p {
        font-size: 9px;
    }
}

@media (max-width: 1300px) {
    .tab-button div span {
        font-size: 16px;
        margin-top: 2px;
    }
}

@media (min-width: 1440px) {
    .tryExam {
        max-width: 1460px;
        margin-right: auto;
        margin-left: auto;
        min-height: 100vh;
    }
}

@media (min-width: 1200px) {
    .containerTryExam,
    .containerTryExam-sm,
    .containerTryExam-md,
    .containerTryExam-lg,
    .containerTryExam-xl {
        max-width: 1460px;
    }
}

@media (min-width: 992px) {
    .col-lg-8 {
        flex: 0 0 70%;
        max-width: 70%;
    }

    .col-lg-4 {
        flex: 0 0 30%;
        max-width: 30%;
    }
}

@media (max-width: 992px) {
    .page-name {
        width: 80vw;
        text-align: center;
    }

    .tryExam-content__mobile--Date {
        justify-content: space-around;
        width: 100%;
    }

    .groupButtonScore {
        width: 100% !important;
    }

    .tryExam-content__mobile {
        margin-bottom: 10px;
        flex-direction: column;
    }

    .total-question {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
    }
}

@media (max-width: 768px) {
    .position-text {
        display: none;
    }

    .containerTryExam,
    .containerTryExam-sm,
    .containerTryExam-md,
    .containerTryExam-lg,
    .containerTryExam-xl {
        width: 96%;
        padding: 10px;
    }

    .questionImage {
        width: 100% !important;
    }

    .card-chart {
        /* display: none; */
    }

    .total-question__desktop {
        display: none;
    }

    .total-question__mobile {
        /* display: block; */
    }

    .tryExam-content__mobile--Date {
        display: flex;
        flex-direction: column;
    }

    .tableQuestion td {
        padding: 10px;
    }

    .tableQuestion {
        border: 1px black solid !important;
    }

    .tableQuestion td + td {
        border-bottom: 1px solid black;
    }

    .selectAnswer {
        display: none !important;
    }

    .analysis-detaile {
        max-width: 348px;
        width: 100%;
        height: 463px;
        background: url('../../assets/images/Exam/try-exam-13.png') 0px 0 no-repeat;
        background-size: 100%;
        margin: 0;
    }

    .analysis-detaile .group {
        width: 95%;
        margin: 0 !important;
        height: 335px;
        padding: 0 28px 28px;
        margin-top: 30px !important;
        display: none;
        position: relative;
        top: auto;
        left: auto;
    }

    .analysis-detaile .group.act {
        display: block;
    }

    .analysis-detaile .group .item {
        margin-bottom: 5px;
    }

    .analysis-detaile .tab-button {
        top: unset;
        bottom: 22px;
        justify-content: space-between;
        padding: 0 20px;
        display: flex;
        position: absolute;
        width: 100%;
    }

    .analysis-detaile .tab-button div {
        width: auto;
        margin: 0;

    }

    .analysis-detaile .tab-button div span {
        margin: 0;
        font-size: 20px;
        color: #D9D9D9;
        font-weight: 500;
        padding: 5px 11px;
        border-radius: 20px;
        border: 1px solid #D9D9D9;
        padding-bottom: 6px;
        position: relative;
        left: auto;
        top: auto;

        display: inline-block;
    }

    .analysis-detaile .tab-button div span.act {

        color: #2A3251;
        padding-left: 43px;
        padding-right: 10px;

    }

    .analysis-detaile .tab-button .b-listen span.act {
        background: #D9D9D9 url('../../assets/images/Exam/try-exam-14.png') 2px 0px no-repeat;
        background-size: 40px;
    }

    .analysis-detaile .tab-button .b-read span.act {
        background: #D9D9D9 url('../../assets/images/Exam/try-exam-15.png') 2px 0px no-repeat;
        background-size: 40px;
    }

    .analysis-detaile .tab-button .b-speak span.act {
        background: #D9D9D9 url('../../assets/images/Exam/try-exam-16.png') 2px 0px no-repeat;
        background-size: 40px;
    }

    .analysis-detaile .tab-button .b-write span.act {
        background: #D9D9D9 url('../../assets/images/Exam/try-exam-17.png') 2px 0px no-repeat;
        background-size: 40px;
    }

    .compare-score div {
        width: 100%;
    }

    .compare-score div p {
        left: 122px;
    }

    .skills-need-advance {
        height: 426px;
        background: url('../../assets/images/Exam/try-exam-18.png') 0px 0 no-repeat;
        background-size: 100%;
        padding: 0;
        overflow: auto;
        position: relative;
        display: flex !important;
        margin-bottom: 20px;
    }

    .skills-need-advance .bg {
        overflow: auto;
        height: 78%;
        margin-top: 38px;
        width: 96.5%;
    }

    .skills-need-advance .gr {
        display: block;
        padding: 0 20px 0 100px;
        position: relative;
        margin-bottom: 20px;
    }

    .skills-need-advance .gr::before {
        content: attr(data-title);
        width: 60px;
        height: 30px;
        background: url('../../assets/images/Exam/try-exam-19.png') 0px 0 no-repeat;
        position: absolute;
        left: 25px;
        top: 0px;
        color: white;
        font-size: 13px;
        padding: 4px 0 0 8px;
    }

    .skills-need-advance .gr:nth-of-type(2n)::before {
        background: url('../../assets/images/Exam/try-exam-20.png') 0px 0 no-repeat;
    }

    .skills-need-advance .gr-2::before {

        padding: 4px 0 0 25px;
    }

    .skills-need-advance .gr-3::before {

        padding: 4px 0 0 14px;
    }

    .skills-need-advance .gr-4::before {

        padding: 4px 0 0 23px;
    }

    .skills-need-advance .gr .item {
        margin-bottom: 8px;
    }

    .skills-need-advance .gr .item p {
        font-size: 13px;
    }

    .skills-need-advance .text-noti {
        position: relative;
        font-size: 13px;
        text-align: left !important;
        display: block;
    }

    .group-slides {
        display: none;
    }

    .analysis-advance .area-recommend {
        height: auto;

    }

    .area-buttons-tabs {
        justify-content: space-around;
    }

    .area-time-complete .t-2 {
        margin: 5px 0 !important;
    }

    /* .chart-score div{
        height: 250px;
    } */
    .des-chart span {
        font-size: 12px;
    }

    .chart-score span {
        font-size: 12px !important;
    }

    .chart-score .x {
        bottom: 3px;
    }

    .no-data-question-type p {
        font-size: 10px;
        top: 33%;
    }

    .area-overview .tt-sub {
        margin: 0 10px 20px !important;
    }

    .note {
        margin: 0px 0 0 10px;
    }

    .area-analysis-score > div {
        margin: 0 10px;
    }

    .analysis-advance .area-recommend .ar-gr {
        height: auto;
    }

    .solution-consulting .t-3 {
        margin: 0 10px;
    }

}
</style>
